window.addEventListener('error', function(e) {
  if (e.message && e.message.includes('Cannot set properties of null')) {
    e.preventDefault();
    return false;
  }
});

if (!window.cartDrawerDecimalInitialized) {
  window.cartDrawerDecimalInitialized = true;

  /* O subtotal com frete somado é escrito pelo `cart-frete.js`, que atende também a
     página /cart. Aqui só se avisa a base (ver `updateSubtotalFromCart`). */
  let isDrawerOpen = false;
  let isUpdating = false;
  let hasDrawerContentInitialized = false;
  let hasDrawerRecommendationsInitialized = false;
  let lastUpdateErrorInfo = null;

  function getCartKeyToProductMap() {
    try {
      const raw = localStorage.getItem('cart_key_to_product');
      return raw ? JSON.parse(raw) : {};
    } catch (_e) {
      return {};
    }
  }

  function saveCartKeyToProductMap(map) {
    try {
      localStorage.setItem('cart_key_to_product', JSON.stringify(map || {}));
    } catch (_e) {}
  }

  function persistCartKeyProductMapFromDOM() {
    try {
      const map = getCartKeyToProductMap();
      document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal[data-key][data-product-id]').forEach(el => {
        const key = el.getAttribute('data-key');
        const pid = (el.getAttribute('data-product-id') || '').toString().replace(/[^0-9]/g, '');
        if (key && pid) {
          map[key] = pid;
          
          const removeButtons = el.querySelectorAll('.remove-item');
          removeButtons.forEach(btn => {
            if (btn.dataset.key !== key) {
              btn.dataset.key = key;
              btn.setAttribute('data-key', key);
            }
          });
        }
      });
      saveCartKeyToProductMap(map);
    } catch (_e) {}
  }

  function getProductIdForKey(key) {
    const node = document.querySelector(`#cart-drawer-decimal .cart-item-decimal[data-key="${CSS.escape(key)}"]`);
    const fromDom = node?.getAttribute('data-product-id');
    if (fromDom && fromDom !== 'null') return fromDom.toString().replace(/[^0-9]/g, '');
    const map = getCartKeyToProductMap();
    if (map && map[key]) return map[key].toString().replace(/[^0-9]/g, '');
    return null;
  }

  function extractProductIdFromKey(key) {
    const mapped = getProductIdForKey(key);
    if (mapped) { return mapped; }

    const possibleIds = [key, key?.split(':')?.[0], key?.split('_')?.[0]].filter(Boolean);
    for (const id of possibleIds) {
      const cleanId = id.toString().replace(/[^0-9]/g, '');
      if (getProductDataFromStorage(cleanId) || getAvailableQuantityFromStorage(cleanId)) { return cleanId; }
      }
    const genericData = localStorage.getItem('unidentified_product');
    if (genericData) {
      return 'generic';
    }
    return null;
  }


  function getProductDataFromStorage(productId) {
    try {
      if (!productId || productId === 'null' || productId === null) {
        const data = localStorage.getItem('unidentified_product');
        if (data) {
          try {
            const productData = JSON.parse(data);
            return productData;
          } catch (parseError) {
          }
        }
      }
      
      const cleanProductId = productId.toString().replace(/[^0-9]/g, '');
      
      const storageKeys = [
        `product_data_${cleanProductId}`,
        `product_data_${productId}`,
        'unidentified_product'
      ];
      
      for (const key of storageKeys) {
        const data = localStorage.getItem(key);
        if (data) {
          try {
            const productData = JSON.parse(data);
            return productData;
          } catch (parseError) {
          }
        }
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }

  function getAvailableQuantityFromStorage(productId) {
    try {
      if (!productId || productId === 'null' || productId === null) {
        const productData = getProductDataFromStorage(null);
        if (productData && productData.availableQuantity !== undefined) {
          return productData.availableQuantity;
        }
      }
      
      const cleanProductId = productId.toString().replace(/[^0-9]/g, '');
      
      const keys = [
        `available_quantity_${cleanProductId}`,
        `available_quantity_${productId}`
      ];
      
      for (const key of keys) {
        const quantity = localStorage.getItem(key);
        if (quantity !== null) {
          const parsed = parseFloat(quantity);
          return parsed;
        }
      }
      
      const productData = getProductDataFromStorage(productId);
      if (productData && productData.availableQuantity !== undefined) {
        return productData.availableQuantity;
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }


  function parseDecimalBR(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      return parseFloat(value.replace(',', '.')) || 0;
    }
    return 0;
  }

  function formatDecimalBR(value) {
    if (typeof value === 'string') {
      value = parseFloat(value.replace(',', '.'));
    }
    if (isNaN(value)) return '0,0';
    return value.toFixed(1).replace('.', ',');
  }

  function createAppProxyUrl(path) {
    // `qty-handler` é o subpath do NOSSO app. `quantity-handler` é do app antigo
    // (Gustavo) — apontar pra lá criaria variante através do app dele.
    return `/apps/${path || 'qty-handler'}`;
  }

  const LOG_MAX_LEN = 600;
  function logSnippet(text) {
    try {
      if (typeof text !== 'string') return text;
      return text.length > LOG_MAX_LEN ? text.slice(0, LOG_MAX_LEN) + '…' : text;
    } catch (_e) {
      return text;
    }
  }

  function isRetryableStatus(status) {
    return [408, 429, 500, 502, 503, 504].includes(Number(status));
  }

  function extractUserMessageFromBody(body) {
    if (!body || typeof body !== 'string') return null;

    try {
      const parsed = JSON.parse(body);
      return parsed?.error || parsed?.message || null;
    } catch (_error) {
      return null;
    }
  }

  function getDefaultUserMessageForStatus(status) {
    if ([429, 503].includes(Number(status))) {
      return 'A loja esta processando muitos pedidos agora. Tente novamente em instantes.';
    }

    return null;
  }

  function getUserFacingErrorMessage(errorInfo, fallbackMessage = 'Nao foi possivel atualizar. Tente novamente.') {
    return errorInfo?.userMessage || extractUserMessageFromBody(errorInfo?.body) || errorInfo?.error || fallbackMessage;
  }


  async function timedFetch(url, options, label) {
    const t0 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    const response = await fetch(url, options);
    const t1 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    return response;
  }

  async function timedFetchWithRetry(url, options, label, retryOptions = {}) {
    const retries = retryOptions.retries ?? 10;
    const delay = retryOptions.delay ?? Math.ceil(2000 / retries);
    let lastError = null;

    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        const response = await timedFetch(url, options, label);
        if (response.ok || attempt >= retries) {
          return response;
        }
      } catch (error) {
        lastError = error;
        if (attempt >= retries) {
          throw error;
        }
      }

      await new Promise(resolve => setTimeout(resolve, delay));
    }

    throw lastError || new Error(`${label || 'request'} failed`);
  }

  // 422 sem mensagem própria segue mudo; com `userMessage` (o add da edição, que desde
  // 16/10 mantém a linha antiga quando falha) a cliente precisa saber que não mudou.
  function shouldSuppressUpdateErrorMessage(errorInfo) {
    return Number(errorInfo?.status) === 422 && !errorInfo?.userMessage;
  }

  function shouldRestartUpdateCycle(errorInfo, attempt, maxAttempts) {
    return (Number(errorInfo?.status) === 422 || isRetryableStatus(errorInfo?.status)) && attempt < maxAttempts;
  }

  function saveProductData(productData) {
    try {
      if (!productData) return;
      const idCandidate = productData.productId || productData.id || productData.variantId;
      if (!idCandidate) return;
      const cleanId = idCandidate.toString().replace(/[^0-9]/g, '');
      const dataToStore = {
        ...productData,
        productId: cleanId,
        timestamp: Date.now()
      };
      localStorage.setItem(`product_data_${cleanId}`, JSON.stringify(dataToStore));
      if (typeof productData.availableQuantity === 'number' && !Number.isNaN(productData.availableQuantity)) {
        localStorage.setItem(`available_quantity_${cleanId}`, String(productData.availableQuantity));
      }
      if (typeof productData.originalQuantity === 'number' && !Number.isNaN(productData.originalQuantity)) {
        localStorage.setItem(`original_quantity_${cleanId}`, String(productData.originalQuantity));
      }
    } catch (err) {
    }
  }

  // Avisos de espera no overlay. A primeira vez de CADA metragem aguarda a Shopify
  // publicar a variante recém-criada (medido: ~5,5s até o /cart/add aceitar, 24s no pior
  // caso). Não dá para encurtar isso do lado do tema — mas um spinner mudo por 8 segundos
  // é lido como site travado, e o cliente clica de novo ou desiste. Devolve a função que
  // cancela os avisos. Rastreia: espera da metragem inédita.
  function avisosDeEspera(metrosFmt) {
    const alvo = document.getElementById('cart-loading-decimal');
    if (!alvo) return () => {};
    let msg = alvo.querySelector('.cart-loading-msg');
    if (!msg) { msg = document.createElement('div'); msg.className = 'cart-loading-msg'; alvo.appendChild(msg); }
    msg.textContent = '';
    const timers = [
      setTimeout(() => { msg.textContent = `Preparando seu corte de ${metrosFmt} m…`; }, 1800),
      setTimeout(() => { msg.textContent = 'Primeira vez nesta medida — só mais um instante…'; }, 4500),
    ];
    return () => { timers.forEach(clearTimeout); msg.textContent = ''; };
  }

  /*
   * Desmente a tarja "Produto esgotou" quando ela é FALSA.
   *
   * Uma variante de corte não tem como "acabar": o app a cria com
   * inventoryItem.tracked=false (sem controle de estoque). Então `variant.available=false`
   * numa linha de corte não significa falta de tecido — significa que o índice da vitrine
   * da Shopify ainda não publicou a variante recém-criada. Comprovado em 23/07/2026: lendo
   * a MESMA variante nova 6x seguidas, a resposta alternou disponível/esgotada por MINUTOS,
   * enquanto uma variante antiga dava disponível sempre.
   *
   * O estoque de verdade é o metafield de metros, que o Liquid já calcula por linha em
   * data-available-quantity (metros livres, descontando o que outras linhas usam). Se ele
   * cobre a metragem pedida, a tarja é mentira — e cara: o Liquid esconde os controles de
   * quantidade junto, então o cliente vê "esgotado" num carrinho perfeito e só lhe resta
   * "Excluir". Rastreia: esgotado fantasma.
   *
   * PRESERVA o caso real: produto despublicado (rascunho) continua avisando, e falta
   * genuína de tecido também.
   */
  function corrigirEsgotadoFalso() {
    document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal.item-unavailable').forEach((item) => {
      if (item.dataset.productInDraft === 'true') return; // despublicado: indisponível DE FATO
      const dispo = parseFloat(item.dataset.availableQuantity);
      const metros = parseFloat(item.dataset.decimalQuantity);
      if (!Number.isFinite(dispo) || !Number.isFinite(metros) || metros <= 0) return; // na dúvida, mantém
      if (dispo + 0.001 < metros) return; // falta tecido de verdade → a tarja está certa
      item.classList.remove('item-unavailable');
      item.querySelectorAll('.out-of-stock-message').forEach((m) => m.remove());
      item.querySelectorAll('.quantity-controls.quantity-decimal-controls').forEach((c) => c.classList.remove('hidden'));
    });
  }

  function showLoading() {
    const loading = document.getElementById('cart-loading-decimal');
    if (loading) loading.style.display = 'flex';
  }

  function hideLoading() {
    const loading = document.getElementById('cart-loading-decimal');
    if (loading) loading.style.display = 'none';
  }
  

  // PERF: aceita um carrinho JÁ LIDO (cartPronto). Quem chama em sequência com o
  // updateSubtotalFromCart deve ler /cart.js uma vez e passar pros dois — antes cada
  // um fazia o SEU próprio GET idêntico (~264ms cada) logo depois da mutação.
  async function updateHeaderCartCountFromCart(cartPronto) {
    /*
     * GUARD DE SEQUÊNCIA, igual ao do `updateSubtotalFromCart`.
     *
     * Esta função é chamada de SEIS lugares, e em vários deles sem argumento — aí cada
     * chamada faz o seu próprio GET /cart.js. Duas leituras podem voltar fora de ordem,
     * e sem isto a ÚLTIMA a chegar escreve, mesmo sendo a mais velha.
     *
     * O sintoma que isso produz não parece bug de corrida: o ícone marca 3 com 2
     * produtos no carrinho (visto pelo Gilberto em 15/08/2026). O número nem é
     * inventado — trocar metragem ADICIONA a linha nova e REMOVE a antiga em paralelo,
     * então o carrinho realmente passa por 3 por uma fração de segundo. Uma leitura que
     * pega esse instante e resolve por último congela o 3 na tela. Some ao recarregar,
     * porque o Liquid redesenha o contador do zero — o que faz parecer coisa de cache.
     *
     * O subtotal já tinha esta proteção (rastreia: bug subtotal 0,00); quem a colocou
     * lá não voltou para o vizinho.
     */
    const seq = (updateHeaderCartCountFromCart._seq = (updateHeaderCartCountFromCart._seq || 0) + 1);
    try {
      let cart = cartPronto;
      if (!cart) {
        const res = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' } });
        if (!res.ok) return false;
        cart = await res.json();
      }
      // Uma chamada mais nova já começou → não sobrescreve o resultado dela.
      if (seq !== updateHeaderCartCountFromCart._seq) return true;
      const count = typeof cart.item_count === 'number' ? cart.item_count : (cart.items ? cart.items.length : 0);
      const targets = document.querySelectorAll('[data-cart-count]');
      targets.forEach(el => {
        try {
          el.textContent = String(count);
          el.setAttribute('data-cart-count', String(count));
          if (count > 0) {
            el.classList.remove('is-empty', 'hidden');
            el.style.display = '';
          } else {
            el.classList.add('is-empty');
          }
        } catch(_){}
      });
      return true;
    } catch (_) {
      return false;
    }
  }

  function waitForElement(selector, timeout = 3000) {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  }

  async function populateDrawerRecommendationsAsync() {
    try {
      await waitForElement('#cart-drawer-decimal .product-recommendations-inline');
      const root = document.querySelector('#cart-drawer-decimal .product-recommendations-inline');
      
      if (!root) {
        return;
      }
      
      if (hasDrawerRecommendationsInitialized) {
        return;
      }
      
      const wrapper = root.querySelector('.swiper-wrapper');
      const carousel = root.querySelector('[data-cart-drawer-recs]');
      
      if (!wrapper || !carousel) {
        return;
      }

      return populateDrawerRecommendations();
    } catch (e) {
    }
  }

  function populateDrawerRecommendations() {
    try {
      const root = document.querySelector('#cart-drawer-decimal .product-recommendations-inline');
      if (!root) return;
      
      if (hasDrawerRecommendationsInitialized) return;
      
      const wrapper = root.querySelector('.swiper-wrapper');
      const carousel = root.querySelector('[data-cart-drawer-recs]');
      if (!wrapper || !carousel) return;

      const limit = root.getAttribute('data-limit') || '8';

      function formatBRL(value) {
        const num = typeof value === 'string' ? parseFloat(value) : value;
        // Preços de /recommendations/products.json e /products/*.js vêm sempre em centavos
        // (inteiros); o limiar antigo (> 1000) exibia R$ 9,00 como R$ 900,00
        const amount = Number.isInteger(num) ? (num / 100) : num;
        try {
          return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount || 0);
        } catch(_) {
          return 'R$ ' + (amount || 0).toFixed(2).replace('.', ',');
        }
      }

      function renderProducts(products) {
        if (!products || !products.length) {
          root.style.display = 'none';
          return;
        }
        wrapper.innerHTML = '';
        products.forEach((p) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          const a = document.createElement('a');
          a.className = 'card-product-cart';
          a.href = p.url || (p.handle ? ('/' + p.handle) : '#');
          const imgSrc = ((p.featured_image && (p.featured_image.url || p.featured_image)) || '');
          const title = (p.title || '').replace(/"/g, '&quot;');
          let priceHtml = '';
          const priceNow = p.price || p.price_min || p.price_max;
          if (priceNow) {
            priceHtml = `<div class="card-product-cart-price"><span class="price-now">${formatBRL(priceNow)}</span><span class="price-unit" style="font-size: 1.2rem; color: #a4a4a4;"> /metro</span></div>`;
          }
          a.innerHTML = `
            <div class="card-product-cart-image">
              <img src="${imgSrc}" alt="${title}">
            </div>
            <div class="card-product-cart-info">
              <div class="card-product-cart-name"><h3>${title}</h3></div>
              ${priceHtml}
            </div>`;
          slide.appendChild(a);
          wrapper.appendChild(slide);
        });
        if (typeof Swiper !== 'undefined') {
          if (!carousel.classList.contains('swiper-initialized')) {
            new Swiper(carousel, {
              slidesPerView: 3.4,
              slidesPerGroup: 1,
              spaceBetween: 5,
              watchSlidesProgress: true,
              navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
              autoplay: { delay: 7000, disableOnInteraction: false },
              breakpoints: {
                768: { spaceBetween: 5, slidesPerView: 4, },
              },
              on: {
                init: function() {
                  const recSection = document.querySelector('#cart-drawer-decimal .cart-drawer-recommendations');
                  if (recSection) recSection.classList.add('is-ready');
                  hasDrawerRecommendationsInitialized = true;
                }
              }
            });
          }
        }
      }

      function loadWithProductId(productId) {
        const url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related';
        fetch(url)
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            const recs = (data && (data.products || data)) || [];
            // SEMPRE busca detalhes: o p.price de /recommendations é o MENOR preço de
            // variante — que agora é o corte de 0,5m (metade do preço/metro), errado.
            // O preço/metro correto é o da variante "Padrão" (a base do produto).
            return Promise.all(recs.map(p => {
              if (!p.handle) return p;
              return fetch('/products/' + p.handle + '.js')
                .then(r => r.ok ? r.json() : null)
                .then(d => {
                  if (d && d.variants && d.variants.length) {
                    // variante Padrão = a base (preço/metro); NÃO usar Math.min (corte 0,5m).
                    const padrao = d.variants.find(v => v.title === 'Padrão' || (v.options && v.options.indexOf('Padrão') !== -1)) || d.variants[0];
                    const pr = typeof padrao.price === 'string' ? parseFloat(padrao.price) : padrao.price;
                    if (pr) p.price = pr;
                    const cmp = typeof padrao.compare_at_price === 'string' ? parseFloat(padrao.compare_at_price) : padrao.compare_at_price;
                    if (cmp) p.compare_at_price = cmp;
                  }
                  return p;
                })
                .catch(() => p);
            }));
          })
          .then((recs) => { if (recs) renderProducts(recs); })
          .catch(() => { root.style.display = 'none'; });
      }

      const explicitPid = root.getAttribute('data-product-id');
      if (explicitPid) {
        loadWithProductId(explicitPid);
      } else {
        fetch('/cart.js')
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            const pid = cart && cart.items && cart.items[0] && cart.items[0].product_id;
            if (pid) loadWithProductId(pid); else root.style.display = 'none';
          })
          .catch(() => { root.style.display = 'none'; });
      }
    } catch (_e) {}
  }

  function initCartDrawerCarousel() {
    try {
      const carouselElement = document.querySelector('#cart-drawer-decimal [data-cart-drawer-carousel]');
      if (!carouselElement) return;
      if (carouselElement.classList.contains('swiper-initialized')) return;

      if (typeof Swiper === 'undefined') return;
      const swiper = new Swiper(carouselElement, {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          init: function() {
            carouselElement.classList.add('swiper-initialized');
          }
        }
      });
      return swiper;
    } catch (e) {
    }
  }

  function setDrawerProcessing(enabled) {
    try {
      const drawer = document.getElementById('cart-drawer-decimal');
      if (!drawer) return;

      const buttons = drawer.querySelectorAll('.quantity-edit-button, .quantity-confirm, .quantity-cancel, .remove-item, .checkout-button');
      buttons.forEach((btn) => {
        if (!btn) return;
        btn.disabled = enabled;
        btn.style.cursor = enabled ? 'not-allowed' : 'pointer';
      });

      if (enabled) {
        showLoading();
      } else {
        hideLoading();
      }
    } catch (err) {
    }
  }

  function isCartTemplate() {
    return document.body.classList.contains('template-cart') || 
           window.location.pathname === '/cart' ||
           window.location.pathname.includes('/cart');
  }

  /**
   * @param {{pularCargaInicial?: boolean}} [opcoes]
   *
   * `pularCargaInicial` existe por causa da PISCADA DUPLA no primeiro add.
   *
   * Medido em 13/08/2026: `add.js` → busca da section → redesenho → segunda busca da
   * section, 71ms depois. Duas reconstruções completas em meio segundo, e cada uma
   * desmonta e remonta a lista de itens.
   *
   * A causa é que o fluxo de adicionar faz duas coisas seguidas: abre o drawer (e a
   * abertura, na primeira vez da sessão, dispara a carga inicial) e logo depois pede
   * um `refreshCartDataComplete`. A segunda é OBRIGATÓRIA — sem ela o subtotal do
   * rodapé fica zerado no primeiro add, ver o comentário no chamador. Então quem sai
   * é a primeira, e só quando se sabe que a completa vem atrás.
   *
   * Sem a opção, a abertura normal (clique no ícone do carrinho) segue idêntica.
   */
  function openCartDrawer(opcoes) {
    const pularCargaInicial = !!(opcoes && opcoes.pularCargaInicial);

    // Não abrir o drawer se estivermos no template cart
    if (isCartTemplate()) {
      return;
    }
    
    const drawer = document.getElementById('cart-drawer-decimal');
    if (drawer) {
      drawer.classList.add('open');
      isDrawerOpen = true;
      document.body.classList.add('drawer-open');
      
      const overlay = drawer.querySelector('.drawer-overlay');
      if (overlay) {
        overlay.classList.add('is-visible');
      }

      if (pularCargaInicial) {
        // Quem chamou reconstrói o conteúdo inteiro em seguida — incluindo as
        // recomendações e o carrossel, que a carga inicial também faria. Marcar como
        // inicializado evita que uma abertura futura refaça a primeira carga.
        hasDrawerContentInitialized = true;
      } else if (!hasDrawerContentInitialized) {
        refreshCartData().then(async () => {
          try {
            hasDrawerRecommendationsInitialized = false;
            await populateDrawerRecommendationsAsync();
            initCartDrawerCarousel();
          } catch (e) {
          }
        }).catch(async () => {
          try {
            hasDrawerRecommendationsInitialized = false;
            await populateDrawerRecommendationsAsync();
            initCartDrawerCarousel();
          } catch (e) {}
        });
        hasDrawerContentInitialized = true;
      } else {
        setTimeout(async () => {
          try {
          initCartDrawerCarousel && initCartDrawerCarousel();
            hasDrawerRecommendationsInitialized = false;
            await populateDrawerRecommendationsAsync();
          } catch (e) {
          }
        }, 50);
      }
    }
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('cart-drawer-decimal');
    if (drawer) {
      drawer.classList.remove('open');
      isDrawerOpen = false;
      document.body.classList.remove('drawer-open');
      
      const overlay = drawer.querySelector('.drawer-overlay');
      if (overlay) {
        overlay.classList.remove('is-visible');
      }
    }
  }

  async function getCartData() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function refreshCartDataComplete() {
    showLoading();
    
    try {
      const response = await fetch(`?section_id=cart-drawer-decimal`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const section = doc.querySelector('#shopify-section-cart-drawer-decimal');
      const cartDrawerContent = section ? section.querySelector('.cart-drawer-content') : doc.querySelector('.cart-drawer-content');
      
      if (cartDrawerContent) {
        const currentContent = document.querySelector('.cart-drawer-content');
        if (currentContent) {
          currentContent.innerHTML = cartDrawerContent.innerHTML;
          // O rodapé foi junto: devolve o bloco de Frete e cupom ao estado escolhido.
          aplicarEstadoExtras();
          // O HTML vem do Liquid, que pode ter renderizado a tarja "esgotou" a partir de
          // uma leitura velha do índice. Corrige ANTES de o cliente ver.
          corrigirEsgotadoFalso();

          const newDrawer = cartDrawerContent.closest('#cart-drawer-decimal') || section?.querySelector('#cart-drawer-decimal');
          const currentDrawer = document.getElementById('cart-drawer-decimal');
          if (newDrawer && currentDrawer) {
            if (newDrawer.classList.contains('cart-empty')) {
              currentDrawer.classList.add('cart-empty');
            } else {
              currentDrawer.classList.remove('cart-empty');
            }
          }
          
          const cartItemsComplete = currentContent.querySelectorAll('.cart-item-decimal');
          const cartEmptyDivComplete = currentContent.querySelector('.cart-empty');
          const isEmptyComplete = cartItemsComplete.length === 0 || !!cartEmptyDivComplete;
          const currentDrawerComplete = document.getElementById('cart-drawer-decimal');
          
          if (currentDrawerComplete) {
            if (isEmptyComplete && !currentDrawerComplete.classList.contains('cart-empty')) {
              currentDrawerComplete.classList.add('cart-empty');
            } else if (!isEmptyComplete && currentDrawerComplete.classList.contains('cart-empty')) {
              currentDrawerComplete.classList.remove('cart-empty');
            }
          }
          
          persistCartKeyProductMapFromDOM();
          
          setTimeout(() => {
            initializeDrawerEvents();
          }, 50);
        }
      } else {
        window.location.reload();
      }
      
    } catch (error) {
      window.location.reload();
    } finally {
      hideLoading();
    }
  }

  // Auto-cura o "Produto esgotou" TRANSITÓRIO: variante de corte recém-criada leva
  // alguns segundos pra propagar available:true na vitrine; se o carrinho renderizar
  // nesse meio, mostra "esgotou". Re-renderiza espaçado até sumir (a variante propaga).
  // One-shot por chamada; para assim que não houver mais "esgotou".
  // Janela de cura do "esgotou" transitório. Medido em 23/07/2026: depois de criar uma
  // variante de corte, o índice da vitrine da Shopify fica EVENTUALMENTE consistente —
  // leituras seguidas do MESMO produto alternam available true/false por MINUTOS (réplicas
  // de borda dessincronizadas). Então o render da seção pode pegar uma réplica velha e
  // mostrar "Produto esgotou" num corte que está perfeito no carrinho. As 4 tentativas de
  // 3,5s (janela de 14s) desistiam muito antes de estabilizar, e o cliente ficava olhando
  // "esgotou" com o preço certo do lado. Agora a janela vai a ~1min45, com intervalos
  // crescentes (barato: para sozinho assim que curar). Rastreia: esgotado fantasma.
  const HEAL_ESPERAS = [3000, 3000, 5000, 5000, 8000, 8000, 12000, 15000, 20000, 25000];
  function agendarAutoHealEsgotado(passo) {
    const i = typeof passo === 'number' ? passo : 0;
    if (i >= HEAL_ESPERAS.length) return;
    setTimeout(async () => {
      if (!document.querySelector('#cart-drawer-decimal .out-of-stock-message')) return; // já curou
      try { await refreshCartDataComplete(); } catch (_) {}
      agendarAutoHealEsgotado(i + 1);
    }, HEAL_ESPERAS[i]);
  }

  async function refreshCartData() {
    if (isUpdating) {
      return;
    }
    
    showLoading();
    
    try {
      const response = await fetch(`?section_id=cart-drawer-decimal`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const section = doc.querySelector('#shopify-section-cart-drawer-decimal');
      const cartDrawerContent = section ? section.querySelector('.cart-drawer-content') : doc.querySelector('.cart-drawer-content');
      
      if (cartDrawerContent) {
        const currentContent = document.querySelector('.cart-drawer-content');
        
        if (currentContent) {
          const newProgressBars = cartDrawerContent.querySelectorAll('[id^="progress-bar-"]');
          const currentProgressBars = currentContent.querySelectorAll('[id^="progress-bar-"]');
          
          /*
           * As barras de frete grátis moram DENTRO do cartão de Entrega, no rodapé.
           * Este bloco arrancava as barras de onde estivessem e as recolocava logo
           * depois do cabeçalho — sobra de quando elas viviam no topo do drawer. Como
           * a atualização não substitui o rodapé (só o corpo), o efeito era a barra
           * "pular" para o topo toda vez que o carrinho mudava, e só então: por isso
           * parecia intermitente, e por isso parecia cache.
           *
           * Barra que já existe fica onde está. Quem atualiza os números é
           * `[id^="progress-bar-"]` buscado no documento inteiro, que não se importa
           * com a posição.
           */
          if (newProgressBars.length === 0) {
            // Carrinho esvaziou (o Liquid só rende as barras com item_count > 0).
            currentProgressBars.forEach(bar => bar.remove());
          } else if (currentProgressBars.length === 0) {
            // Não existem porque o carrinho estava vazio e voltou a ter item: recria no
            // lugar certo, que é logo depois do resultado do frete, como no Liquid.
            const ancora = currentContent.querySelector('.cbv-frete__resultado');
            if (ancora) {
              // Uma inserção só: `afterend` repetido na mesma âncora inverteria a ordem
              // das três barras.
              ancora.insertAdjacentHTML(
                'afterend',
                Array.from(newProgressBars).map(bar => bar.outerHTML).join(''),
              );
            }
          }
          
          const newBody = cartDrawerContent.querySelector('.cart-drawer-body');
          const currentBody = currentContent.querySelector('.cart-drawer-body');
          if (newBody && currentBody) {
            currentBody.innerHTML = newBody.innerHTML;
            aplicarEstadoExtras();
          }
          
          const newDrawer = cartDrawerContent.closest('#cart-drawer-decimal') || section?.querySelector('#cart-drawer-decimal');
          const currentDrawer = document.getElementById('cart-drawer-decimal');
          if (newDrawer && currentDrawer) {
            if (newDrawer.classList.contains('cart-empty')) {
              currentDrawer.classList.add('cart-empty');
            } else {
              currentDrawer.classList.remove('cart-empty');
            }
          }
          
          const cartItems = currentContent.querySelectorAll('.cart-item-decimal');
          const cartEmptyDiv = currentContent.querySelector('.cart-empty');
          const isEmpty = cartItems.length === 0 || !!cartEmptyDiv;
          const currentDrawerFinal = document.getElementById('cart-drawer-decimal');
          
          if (currentDrawerFinal) {
            if (isEmpty && !currentDrawerFinal.classList.contains('cart-empty')) {
              currentDrawerFinal.classList.add('cart-empty');
            } else if (!isEmpty && currentDrawerFinal.classList.contains('cart-empty')) {
              currentDrawerFinal.classList.remove('cart-empty');
            }
          }

          persistCartKeyProductMapFromDOM();
          
          setTimeout(() => {
            const quantityInputs = document.querySelectorAll('#cart-drawer-decimal .quantity-input');
            
            quantityInputs.forEach((input, index) => {
              if (input.value && input.value.includes(',')) {
                // O campo é o que o CLIENTE lê: fica em pt-BR (vírgula). Só o dado interno
                // guarda o formato canônico com ponto. Antes o valor exibido era
                // sobrescrito com ponto e a linha aparecia como "12.3" no drawer enquanto
                // a /cart mostrava "12,3". Rastreia: vírgula na metragem.
                const americanValue = input.value.replace(',', '.');
                if (!input.dataset.originalValue) {
                  input.dataset.originalValue = americanValue;
                }
              }
            });
            
            initializeQuantityControls();
            // O .subtotal fica FORA do .cart-drawer-body (que é o único re-renderizado
            // aqui), então precisa ser atualizado explicitamente — senão no PRIMEIRO
            // add o subtotal fica no valor da carga da página (0,00). O guard de
            // sequência garante que só a leitura mais nova vença. Rastreia: bug subtotal.
            try { updateSubtotalFromCart(); } catch (_) {}
            // Update minimum order display after refresh
            getCartData().then(cart => {
              if (cart) {
                updateMinimumOrderDisplay(cart);
              }
            }).catch(() => {});
            
            // Initial update when page loads
            setTimeout(() => {
              getCartData().then(cart => {
                if (cart) {
                  updateMinimumOrderDisplay(cart);
                }
              }).catch(() => {});
            }, 200);
          }, 50);
        }
      } else {
        window.location.reload();
      }
      
    } catch (error) {
      window.location.reload();
    } finally {
      hideLoading();
    }
  }

  // ── updateCartQuantity (reescrito CBV app novo): UMA chamada ao App Proxy via
  //    window.DecimalCut.resolverCorte (timeout + retry transitório embutido).
  //    Sem o loop duplo antigo (que fazia ~6 chamadas). Mantém isUpdating,
  //    showLoading e updateDrawerUIInPlace. Rastreia: bug perf edição no carrinho.
  async function updateCartQuantity(key, decimalQuantity, realQuantity) {
    if (isUpdating) return false;
    isUpdating = true;
    showLoading();
    try {
      const itemElement = document.querySelector(`.cart-item-decimal[data-key="${key}"]`);
      if (!itemElement) { window.cartDrawerDecimalLastError = { step: 'prepare', reason: 'item não encontrado', key }; return false; }
      const numericProductId = (itemElement.dataset.productId || '').toString().replace(/[^0-9]/g, '');
      if (!numericProductId) { window.cartDrawerDecimalLastError = { step: 'prepare', reason: 'sem productId' }; return false; }
      // Preço/metro CONFIÁVEL = preço da variante ÷ metragem atual (via /cart.js), em
      // vez da propriedade 'Valor por metro' (data-price-per-meter), que pode estar
      // POLUÍDA por edições antigas (gravada como total, não por metro). Editar então
      // AUTO-CORRIGE a propriedade. Fallback: o dataset. Rastreia: bug preço/metro poluído.
      let pricePerMeter = parseFloat(itemElement.dataset.pricePerMeter || '0') || 0;
      // PERF: uma ÚNICA leitura do carrinho serve para os DOIS usos — o preço/metro real
      // aqui e o índice da linha antiga no remove lá embaixo. O prepararCorte no meio só
      // mexe no CATÁLOGO (resolve/cria a variante), nunca no carrinho, então este snapshot
      // continua válido. Antes eram 2 GETs /cart.js (~264ms cada) por mudança de quantidade.
      let cartAntes = null;
      try {
        cartAntes = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const it = (cartAntes.items || []).find((i) => i.key === key);
        if (it && it.price > 0) {
          const q = it.properties && it.properties['_Quantidade'];
          const m = q ? (parseFloat(String(q).replace(/[^\d.]/g, '')) || 0) : 0; // "8.0 metros" → 8.0
          if (m >= 0.5) pricePerMeter = Math.round((it.price / 100 / m) * 100) / 100;
        }
      } catch (_) {}
      if (!Number.isFinite(pricePerMeter) || pricePerMeter <= 0) { window.cartDrawerDecimalLastError = { step: 'prepare', reason: 'preço/metro inválido' }; return false; }
      const productTitle = itemElement.querySelector('.cart-item-title')?.textContent?.trim() || '';

      // DecimalCut vem do decimal-quantity.js (agora carregado site-wide junto do
      // carrinho). Guard defensivo: se faltar, falha claro em vez do erro críptico.
      if (!window.DecimalCut || typeof window.DecimalCut.prepararCorte !== 'function') {
        window.cartDrawerDecimalLastError = { step: 'prepare', reason: 'DecimalCut indisponível (decimal-quantity.js não carregou)' };
        return false;
      }

      // NÚCLEO: prepararCorte resolve a variante E garante disponível, usando o CACHE
      // do pré-aquecimento. Se a metragem já foi aquecida, retorna NA HORA (add rápido).
      // Se a variante nova não propagar a tempo, ABORTA sem tocar no carrinho — não
      // remove a linha antiga, evitando o estado quebrado (esgotou + subtotal 0).
      let newVariantId;
      try {
        const prep = await window.DecimalCut.prepararCorte(numericProductId, decimalQuantity, productTitle, pricePerMeter, itemElement.dataset.productHandle || '');
        if (!prep.ready) {
          window.cartDrawerDecimalLastError = { step: 'nao-propagou', reason: 'variante nova indisponível a tempo — item mantido no valor anterior' };
          return false;
        }
        newVariantId = prep.variantId;
      } catch (e) {
        window.cartDrawerDecimalLastError = { step: 'proxy', error: e?.message || String(e) };
        return false;
      }

      // ── ADICIONAR A NOVA, CONFERIR, E SÓ ENTÃO REMOVER A ANTIGA ────────────────
      //
      // POR QUE NÃO `/cart/update.js` (que faria a troca numa chamada só). Testado
      // em produção 28/07/2026: troca a variante em 543ms e devolve a linha nova com
      // `properties: {}` — APAGA o `_Quantidade`. Esse campo é o que diz quantos
      // metros o cliente comprou; sem ele some a metragem na tela, no checkout e na
      // conferência de estoque. E o preço continuaria certo (mora na variante), então
      // o defeito passaria batido em teste. Descartado.
      //
      // POR QUE NÃO EM PARALELO (como foi até 16/10/2026). Remove e add saíam juntos
      // e ganhavam ~114ms, mas o remove não esperava saber se o add tinha dado certo.
      // Add recusado (422 duas vezes, 429, rede, ou a conferência de preço do #6663
      // tirando a linha nova) = a antiga já tinha ido embora: o tecido SUMIA do
      // carrinho, e a tela, que não se redesenha na falha, continuava mostrando a
      // linha. Visto no teste de 16/10 (7,3 → 8,7 m). Agora a antiga só sai depois
      // da nova gravada e conferida; se algo falhar, o carrinho fica como estava.
      // O pior caso passa a ser as duas linhas por um instante (aba fechada entre o
      // add e o remove) — visível e corrigível pela cliente, ao contrário do sumiço.
      //
      // O remove aponta a linha pela CHAVE (`id`), não pelo índice: o add muda a
      // ordem das linhas, a chave da antiga não muda.
      let chaveRemover = null;
      let varDaLinha = itemElement.dataset.variantId || '';
      /*
       * O `SKU` da linha atual é CARREGADO ADIANTE, não recalculado.
       *
       * Este trecho recria a linha, e `properties` substitui tudo: qualquer campo que
       * não for reenviado desaparece. Foi assim que o `_Quantidade` quase se perdeu na
       * troca por `/cart/update.js` (ver o comentário acima). O `SKU` corre o mesmo
       * risco — só que pior, porque sumiria SÓ nas linhas que a cliente editou, e o
       * pedido chegaria com SKU em umas e não em outras. Erro que ninguém liga à causa.
       *
       * Copiar do item existente, em vez de buscar o do produto, é o certo: é o valor
       * que já estava naquela linha, seja qual for a origem dele.
       */
      let skuDaLinha = '';
      try {
        // PERF: reusa o snapshot lido no início — o proxy não altera o carrinho.
        // Só relê se aquela primeira leitura tiver falhado.
        const cart = cartAntes || await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const itens = cart.items || [];
        let alvo = itens.find((i) => i.key === key);
        /*
         * Plano B pela VARIANTE, antes do handle.
         *
         * Cada metragem é uma variante distinta, então o id da variante identifica
         * ESTA linha. O handle identifica só o tecido — e numa loja de corte é normal
         * a cliente ter o mesmo tecido em duas metragens, então ele pegava a primeira
         * que achasse, que podia ser a outra linha, a que ela quis mesmo ter.
         */
        if (!alvo) {
          const varAntiga = itemElement.dataset.variantId || '';
          if (varAntiga) alvo = itens.find((i) => String(i.variant_id) === String(varAntiga));
        }
        /*
         * SEM plano C por handle (16/10/2026): se nem a chave nem a variante desta linha
         * estão no carrinho, a linha já saiu (outra aba, tela velha) — e o handle achava
         * a OUTRA metragem do mesmo tecido e a removia. A `key` abaixo é inofensiva.
         */
        /*
         * NÃO ACHOU? USA A `key` QUE VEIO MESMO ASSIM.
         *
         * Aqui ficava `null`, e `null` fazia a remoção nem ser TENTADA — o add
         * seguia sozinho e sobravam as duas linhas do mesmo tecido no carrinho, que
         * a cliente paga se não perceber.
         *
         * O snapshot `cartAntes` é lido ANTES do `prepararCorte`, que pode levar
         * segundos criando a variante nova; nesse intervalo o carrinho pode ter
         * mudado e a busca falhar mesmo com a linha existindo. Remover por uma chave
         * que já não existe é inofensivo — a Shopify devolve o carrinho sem mudança.
         * Não remover é sempre o pior lado, então a ramificação `null` não tinha uso
         * legítimo nenhum.
         */
        chaveRemover = alvo ? alvo.key : key;
        if (alvo && alvo.variant_id) varDaLinha = String(alvo.variant_id);
        if (alvo && alvo.properties && alvo.properties.SKU) skuDaLinha = String(alvo.properties.SKU).trim();
      } catch (e) { /* segue: o add cria/funde de qualquer forma */ }

      const removerLinha = (chave) => fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: chave, quantity: 0 }),
      });

      // adiciona a nova (o Shopify funde se já existir a mesma variante+properties)
      // quantity SEMPRE inteiro ≥1: num corte a metragem é a variável, a unidade é 1.
      // realQuantity vinha NaN (data-real-quantity ausente após re-render) → JSON
      // serializava quantity:null → Shopify respondia 422. Rastreia: bug add 422.
      const addQty = (Number.isInteger(realQuantity) && realQuantity > 0) ? realQuantity : 1;
      const precoFmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(pricePerMeter);
      const propriedadesNovas = { '_Quantidade': `${decimalQuantity.toFixed(1)} metros`, 'Valor por metro': precoFmt };
      if (skuDaLinha) propriedadesNovas.SKU = skuDaLinha;
      const addBodyJson = JSON.stringify({ items: [{ id: parseInt(newVariantId, 10), quantity: addQty, properties: propriedadesNovas }] });
      // sondagem acima já garante propagação → ~1 request. Em 429 PARAMOS (retentar
      // prolonga o bloqueio); só 422/5xx ganham 1 retry gentil.
      const DELAYS = [2500];
      async function enviarAdd() {
        let resp;
        for (let i = 0; i <= DELAYS.length; i++) {
          resp = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: addBodyJson,
          });
          if (resp.ok) break;
          if (resp.status === 429) break; // rate limit → não retenta
          if (resp.status === 422 || resp.status >= 500) {
            if (i < DELAYS.length) await new Promise((r) => setTimeout(r, DELAYS[i]));
            continue;
          }
          break; // erro definitivo
        }
        return resp;
      }

      // Mesma variante = mesma metragem: não há o que trocar. E adicionar antes de
      // remover FUNDIRIA as duas (mesma variante e mesmas properties → quantidade 2),
      // e o remove pela chave apagaria a linha fundida — o tecido sumiria.
      const mesmaVariante = !!varDaLinha && String(varDaLinha) === String(newVariantId);

      if (!mesmaVariante) {
        const addResp = await enviarAdd();
        if (!addResp || !addResp.ok) {
          let addBody = '';
          try { addBody = await addResp.text(); } catch (_) {}
          const st = addResp ? addResp.status : 0;
          window.cartDrawerDecimalLastError = {
            step: 'add', status: st, body: addBody.slice(0, 300),
            userMessage: st === 429
              ? 'Muitas tentativas seguidas. Aguarde alguns segundos e tente de novo.'
              : 'Não foi possível atualizar agora. A metragem anterior foi mantida — tente de novo.',
          };
          return false;
        }

        // Confere a LINHA gravada: título de reserva ou preço diferente do que o proxy
        // mandou = o carrinho pegou a foto antiga da variante, e o corte sairia a preço de
        // 1 metro (#6663). Mesma regra do cartAdd do decimal-quantity.js.
        let chaveNova = null;
        try {
          const DC = window.DecimalCut;
          const j = await addResp.clone().json();
          const it = j && Array.isArray(j.items) ? j.items[0] : null;
          if (it) chaveNova = it.key;
          if (DC && DC.ehReserva && it && (DC.ehReserva(it.variant_title) || !DC.precoConfere(newVariantId, it.original_price))) {
            // Tira SÓ o que este add pôs. Se a variante já estava noutra linha com as
            // mesmas properties, a Shopify fundiu e `it.quantity` é a soma — zerar a
            // linha apagaria a outra também. A antiga ainda está lá: nada se perdeu.
            await fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: Math.max(0, (Number(it.quantity) || addQty) - addQty) }),
            }).catch(() => null);
            window.cartDrawerDecimalLastError = {
              step: 'preco-desatualizado', reason: 'linha gravada com título de reserva ou preço velho — retirada',
              userMessage: 'O corte ainda está sendo preparado. Aguarde alguns segundos e tente de novo.',
            };
            return false;
          }
        } catch (_) { /* resposta ilegível: segue, a trava do Finalizar ainda confere */ }

        // Só agora a antiga sai. Se o remove falhar duas vezes, seguimos: a metragem
        // pedida ESTÁ no carrinho, e o re-render logo abaixo mostra as duas linhas para
        // a cliente excluir a que sobrou — melhor do que acusar erro numa ação que deu certo.
        if (chaveRemover && chaveRemover !== chaveNova) {
          let ok = false;
          for (let t = 0; t < 2 && !ok; t++) {
            try { const r = await removerLinha(chaveRemover); ok = r.ok; } catch (_) {}
          }
          if (!ok) window.cartDrawerDecimalLastError = { step: 'remove', reason: 'linha antiga ficou no carrinho junto com a nova' };
        }
      }

      // Re-render COMPLETO a partir do carrinho REAL (mesmo padrão do removeCartItem,
      // que funciona): sincroniza subtotal + linhas + data-key corretos. Evita a
      // dessincronia (linha 68,77 vs subtotal 29,90) e o key velho que fazia a
      // PRÓXIMA edição falhar antes do proxy. Rastreia: bug edição no carrinho.
      const wasUpdating = isUpdating;
      isUpdating = false;
      // PERF: o render da seção (HTML) e a leitura do carrinho (JSON) não dependem um do
      // outro → vão em PARALELO. Depois o MESMO carrinho alimenta subtotal e contador, em
      // vez de cada um disparar seu próprio GET /cart.js idêntico. Eram 3 idas em sequência
      // (~790ms), virou 1 rodada (~264ms). O subtotal continua sendo escrito DEPOIS do
      // render da seção, senão o HTML do Liquid sobrescreveria o valor corrigido.
      const [, cartDepois] = await Promise.all([
        refreshCartDataComplete(),
        fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' } })
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null),
      ]);
      isUpdating = wasUpdating;
      // cartDepois null (leitura falhou) → passa undefined e cada um relê sozinho (fallback).
      try { await updateSubtotalFromCart(cartDepois || undefined); } catch (_) {}
      try { await updateHeaderCartCountFromCart(cartDepois || undefined); } catch (_) {}
      // avisa a PDP p/ recalcular o estoque disponível (ela ouve 'cart:updated').
      try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (_) {}
      agendarAutoHealEsgotado(); // some sozinho o "esgotou" transitório da propagação
      return true;
    } catch (error) {
      window.cartDrawerDecimalLastError = { step: 'catch', error: error?.message || String(error) };
      return false;
    } finally {
      isUpdating = false;
    }
  }

  /*
   * REMOVE SEMPRE PELA CHAVE (16/10/2026). A versão anterior podia apagar OUTRA linha:
   *  • chave fora da tela (2º clique na lixeira, drawer redesenhado) → pegava "o
   *    primeiro outro botão de remover" do drawer e apagava ESSE item;
   *  • chave fora do carrinho → procurava por produto+metragem e depois por HANDLE, e
   *    apagava a outra metragem do mesmo tecido;
   *  • removia por POSIÇÃO (`line:`) depois de um GET — qualquer mudança no meio (outra
   *    aba, a PDP trocando a linha) deslocava o índice.
   * Agora: a chave clicada, e só ela. Chave que já não está no carrinho = a linha já
   * saiu (2º clique, outra aba) → só redesenha. Um 2º clique na mesma lixeira enquanto
   * a 1ª remoção corre é ignorado.
   */
  const chavesRemovendo = new Set();

  async function removeCartItem(key) {
    if (!key || chavesRemovendo.has(key)) return false;
    chavesRemovendo.add(key);
    try {
      return await removerPelaChave(key);
    } finally {
      chavesRemovendo.delete(key);
    }
  }

  async function removerPelaChave(key) {
    if (isUpdating) {
      let attempts = 0;
      while (isUpdating && attempts < 10) {
        await new Promise(resolve => setTimeout(resolve, 200));
        attempts++;
      }
      
      if (isUpdating) {
        return false;
      }
    }
    
    isUpdating = true;
    
    showLoading();
    
    const cartItem = document.querySelector(`.cart-item-decimal[data-key="${key}"]`) || document.querySelector(`[data-key="${key}"]`);
    
    try {
      const mandarRemocao = () => fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      let removeResp = await mandarRemocao();
      if (removeResp.status === 429) {
        await new Promise(resolve => setTimeout(resolve, 1200));
        removeResp = await mandarRemocao();
      }

      let result = null;
      if (removeResp.ok) {
        result = await removeResp.json();
      } else {
        // A chave já não está no carrinho? Então a linha já saiu (2º clique, outra
        // aba, tela velha): é só redesenhar com o carrinho real — nada a remover.
        try {
          const r = await fetch(`/cart.js?ts=${Date.now()}`, { cache: 'no-store' });
          const atual = r.ok ? await r.json() : null;
          if (atual && !(atual.items || []).some(i => i.key === key)) result = atual;
        } catch (_) {}
      }

      if (result) {
        
        const wasUpdating = isUpdating;
        isUpdating = false;
        
        await refreshCartDataComplete();
        
        isUpdating = wasUpdating;
        
        // PERF: `result` É o carrinho já atualizado — /cart/change.js devolve o carrinho
        // inteiro, mesmo formato do /cart.js. Alimenta subtotal e contador direto dele em
        // vez de disparar 2 GETs /cart.js idênticos logo depois (~530ms de ida e volta à toa).
        try { await updateSubtotalFromCart(result); } catch (_) {}
        try { await updateHeaderCartCountFromCart(result); } catch (_) {}
        // avisa a PDP p/ recalcular o estoque disponível (remover devolve metros).
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (_) {}

        setTimeout(() => {
          const remainingItem = document.querySelector(`[data-key="${key}"]`);
          if (remainingItem) {
            remainingItem.remove();
          }

          // Disparar evento customizado para notificar remoção de item
          document.dispatchEvent(new CustomEvent('cartItemRemoved', {
            detail: { key, productId: cartItem?.dataset.productId }
          }));
        }, 100);
        
        return true;
      } else {
        try {
          const errorText = await removeResp.text();
        } catch (e) {
        }
        
        window.location.reload();
        return false;
      }
    } catch (error) {
      window.location.reload();
      return false;
    } finally {
      hideLoading();
      isUpdating = false;
    }
  }

  // PERF: aceita um carrinho JÁ LIDO (cartPronto) para não repetir o GET /cart.js que
  // quem chama acabou de fazer. Sem argumento, lê por conta própria (comportamento antigo).
  async function updateSubtotalFromCart(cartPronto) {
    // GUARD DE SEQUÊNCIA (race-proof): várias chamadas concorrem (otimista com
    // carrinho vazio, pós-mutação com carrinho real). Só a chamada MAIS RECENTE
    // pode escrever o subtotal — senão uma leitura velha (carrinho vazio → 0,00)
    // resolvia depois e sobrescrevia o valor certo. Rastreia: bug subtotal 0,00.
    const seq = (updateSubtotalFromCart._seq = (updateSubtotalFromCart._seq || 0) + 1);
    try {
      let cart = cartPronto;
      if (!cart) {
        const res = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-store' } });
        if (!res.ok) throw new Error('cart.js request failed: ' + res.status);
        cart = await res.json();
      }

      // uma chamada mais nova já começou → não sobrescreve o resultado dela
      if (seq !== updateSubtotalFromCart._seq) return true;

      // items_subtotal_price = subtotal de MERCADORIA, sem o desconto automático de
      // PIX (que é por forma de pagamento e só se aplica no checkout quando o cliente
      // escolhe PIX). total_price INCLUI o PIX → mostrava um subtotal menor pra todo
      // mundo, enganando quem paga no cartão. items_subtotal_price reflete cupons
      // reais de produto (line-level) mas NÃO o PIX (order-level). Rastreia: bug PIX no subtotal.
      const subtotalCents = cart.items_subtotal_price || 0;
      /*
       * Quem ESCREVE a linha de Subtotal é o `cart-frete.js`, não este arquivo.
       *
       * Aqui só se informa a base, e ele soma o frete escolhido por cima antes de
       * escrever. Com dois escritores, a última chamada venceria e o frete apareceria
       * ou sumiria conforme a ordem em que resolvessem — bug que só dá as caras com a
       * rede lenta.
       *
       * `definirBase` também zera a cotação, e isso é deliberado: o carrinho mudou, e
       * o frete daquela consulta não vale mais porque depende do peso.
       *
       * O `if` não é defensivo à toa: se o asset falhar em carregar, é melhor o
       * subtotal ficar parado no valor anterior do que a atualização inteira do
       * carrinho morrer num ReferenceError.
       */
      if (window.cbvFrete) window.cbvFrete.definirBase(subtotalCents);

      // Update minimum order display (only show/hide, message comes from Liquid)
      updateMinimumOrderDisplay(cart);
      
      return true;
    } catch (error) {
      console.error('❌ Erro ao atualizar subtotal:', error);
      return false;
    }
  }

  function isPixDiscount(discount) {
    const title = String(discount?.title || discount?.code || discount?.discount_application?.title || '').toLowerCase();
    return title.includes('pix');
  }

  function getAppliedCouponDiscounts(discounts = []) {
    return discounts.filter(discount => discount.type === 'discount_code' && !isPixDiscount(discount));
  }

  /*
   * O cupom aplicado virou ETIQUETA no cabeçalho do cartão, no lugar da ação — mesmo
   * idioma do CEP no cartão de Entrega. Antes ele era um bloco solto no rodapé, e o
   * cartão continuava oferecendo "Adicionar" ao lado: duas coisas falando do mesmo
   * cupom em lugares diferentes.
   *
   * Por isso os dois andam JUNTOS e numa função só. Estavam em três lugares soltos, e
   * bastava um deles esquecer da ação para sobrar "Adicionar" ao lado de um cupom já
   * aplicado. Também fecha o corpo do cartão: com cupom aplicado não há o que digitar.
   */
  function mostrarCupomAplicado(aplicado) {
    const etiqueta = document.getElementById('cart-drawer-applied-coupon');
    const acao = document.getElementById('drawer-cupom-abrir');
    const corpo = document.getElementById('drawer-cupom-corpo');
    if (etiqueta) etiqueta.style.display = aplicado ? 'inline-flex' : 'none';
    if (acao) acao.hidden = !!aplicado;
    if (aplicado && corpo) corpo.hidden = true;
  }

  function updateDiscountDisplay(cart) {
    const discountDiv = document.getElementById('cart-drawer-discount');
    const discountValue = document.getElementById('cart-drawer-discount-value');
    const appliedCouponCode = document.getElementById('cart-drawer-applied-coupon-code');

    if (!discountDiv || !discountValue) {
      return;
    }

    // Check if there are applied discounts
    
    // Check for cart-level discounts first
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      const appliedCoupons = getAppliedCouponDiscounts(cart.cart_level_discount_applications);
      
      if (appliedCoupons.length > 0) {
        const appliedCoupon = appliedCoupons[0];
        const couponCode = appliedCoupon.title;
        const discountAmount = appliedCoupon.total_allocated_amount || 0;
        
        // Show applied coupon
        if (appliedCouponCode) {
          appliedCouponCode.textContent = couponCode.toUpperCase();
        }
        mostrarCupomAplicado(true);
        
        // Show discount with actual amount
        discountDiv.style.display = 'flex';
        const formattedAmount = formatMoneyCentsBRL(discountAmount);
        const displayValue = formattedAmount.startsWith('-') ? formattedAmount : `-${formattedAmount}`;
        discountValue.textContent = displayValue;
        
        return;
      }
    }
    
    // Sem cupom de NÍVEL DE CARRINHO: procura cupom REAL (código digitado) nas
    // alocações de LINHA e SOMA por título (alocação "each": o mesmo cupom vira N
    // alocações parciais em N linhas). NÃO conta o desconto automático de PIX — ele
    // baixa o preço mas NÃO é cupom.
    //
    // O código antigo usava `original_total_price > total_price` como gatilho e, ao
    // não achar código, mostrava o texto genérico "CUPOM". Com PIX (que baixa o
    // preço mas não tem código), isso virava um "Cupom aplicado: CUPOM" FANTASMA,
    // com valor errado e um "×" que não removia nada — não há código pra remover.
    // Rastreia: bug cupom fantasma no drawer (PIX).
    const cupons = [];
    const somarCupom = (title, amount) => {
      const j = cupons.find((c) => c.title === title);
      if (j) j.amount += amount; else cupons.push({ title, amount });
    };
    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((a) => {
        const app = a.discount_application;
        if (app && app.type === 'discount_code' && !isPixDiscount(app)) {
          somarCupom(app.title, a.amount || 0);
        }
      });
    });

    if (cupons.length > 0) {
      const c = cupons[0];
      if (appliedCouponCode) appliedCouponCode.textContent = String(c.title).toUpperCase();
      mostrarCupomAplicado(true);
      discountDiv.style.display = 'flex';
      const formattedAmount = formatMoneyCentsBRL(c.amount);
      discountValue.textContent = formattedAmount.startsWith('-') ? formattedAmount : `-${formattedAmount}`;
    } else {
      // Só desconto automático (PIX) ou nenhum: não mostrar cupom nem linha de desconto.
      discountDiv.style.display = 'none';
      mostrarCupomAplicado(false);
    }
  }

  function updateMinimumOrderDisplay(cart) {
    const minimumWarning = document.getElementById('minimum-order-warning');
    const checkoutButton = document.querySelector('#cart-drawer-decimal .checkout-button');
    
    if (!minimumWarning && !checkoutButton) {
      return;
    }

    // Get minimum order value from data attribute
    const minimumValueCents = minimumWarning ? parseInt(minimumWarning.getAttribute('data-minimum')) : 5000;
    
    // items_subtotal_price (sem o PIX), consistente com o Liquid do mínimo. Usar
    // total_price aqui contava o desconto de PIX contra o mínimo — pedia mais do
    // que o necessário ("adicione mais R$X" inflado). Rastreia: bug PIX no mínimo.
    const subtotalCents = cart.items_subtotal_price || 0;

    const isMinimumReached = subtotalCents >= minimumValueCents;

    // Control display and update message dynamically
    if (minimumWarning) {
      if (isMinimumReached) {
        minimumWarning.style.display = 'none';
      } else {
        minimumWarning.style.display = 'flex';
        
        // Update message with current values
        const remainingCents = minimumValueCents - subtotalCents;
        const remainingFormatted = formatMoneyCentsBRL(remainingCents);
        const minimumFormatted = formatMoneyCentsBRL(minimumValueCents);
        
        const messageElement = minimumWarning.querySelector('.minimum-order-title');
        const detailElement = minimumWarning.querySelector('.minimum-order-detail');
        
        if (messageElement && detailElement) {
          messageElement.textContent = `Valor mínimo do pedido: ${minimumFormatted}`;
          detailElement.textContent = `Adicione mais ${remainingFormatted} para finalizar sua compra`;
        }
      }
    }

    // Control checkout button
    if (checkoutButton) {
      if (isMinimumReached) {
        // Enable checkout button
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled');
        if (checkoutButton.tagName === 'BUTTON') {
          // Convert button to link if it was disabled
          const link = document.createElement('a');
          link.href = '/checkout';
          link.className = checkoutButton.className.replace('disabled', '');
          link.innerHTML = checkoutButton.innerHTML;
          checkoutButton.parentNode.replaceChild(link, checkoutButton);
        }
      } else {
        // Disable checkout button
        if (checkoutButton.tagName === 'A') {
          // Convert link to button if it was enabled
          const button = document.createElement('button');
          button.type = 'button';
          button.className = checkoutButton.className + ' disabled';
          button.disabled = true;
          button.innerHTML = checkoutButton.innerHTML;
          checkoutButton.parentNode.replaceChild(button, checkoutButton);
        } else {
          checkoutButton.disabled = true;
          checkoutButton.classList.add('disabled');
        }
      }
    }
  }

  function updateSubtotal() {
    try {
      // updateSubtotal() chamada - esta função não considera descontos!
      // Esta função não deve ser usada quando há descontos aplicados
      // Ela calcula apenas o subtotal dos itens sem considerar cupons
      const cartItems = document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal');
      let total = 0;
      
      cartItems.forEach(item => {
        const pricePerMeter = parseFloat(item.dataset.pricePerMeter || '0');
        const decimalQuantity = parseFloat(item.dataset.decimalQuantity || '0');
        const realQuantity = parseInt(item.dataset.realQuantity || '1', 10);
        
        if (pricePerMeter > 0 && decimalQuantity > 0 && realQuantity > 0) {
          const lineTotal = pricePerMeter * decimalQuantity * realQuantity;
          total += lineTotal;
        }
      });
      
      const subtotalElement = document.querySelector('#cart-drawer-decimal .subtotal');
      if (subtotalElement) {
        subtotalElement.textContent = `Subtotal: ${formatMoneyCentsBRL(Math.round(total * 100))}`;
      }
    } catch (error) {
    }
  }

  function formatMoneyCentsBRL(cents) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
    } catch (_e) {}
    const amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount);
    } catch (_e2) {
      return 'R$ ' + amount.toFixed(2).replace('.', ',');
    }
  }

  async function updateDrawerUIInPlace({ itemElement, pricePerMeter, decimalQuantity, realQuantity, productId, newVariantId }) {
    try {
      const lineTotal = pricePerMeter * decimalQuantity * realQuantity;
      const priceElement = itemElement.querySelector('.cart-item-price');
      if (priceElement) {
        priceElement.textContent = formatMoneyCentsBRL(Math.round(lineTotal * 100));
      }
      const input = itemElement.querySelector('.quantity-input');
      if (input) {
        input.value = decimalQuantity.toFixed(1).replace('.', ',');
        input.dataset.originalValue = decimalQuantity.toFixed(1);
      }
      itemElement.dataset.decimalQuantity = String(decimalQuantity);
      itemElement.dataset.realQuantity = String(realQuantity);

      const cartResp = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { 'Cache-Control': 'no-store' } });
      if (!cartResp.ok) return;
      const cart = await cartResp.json();

      const subtotal = parseInt(cart.total_price || cart.items_subtotal_price || 0, 10);
      
      const allProgressBars = document.querySelectorAll('[id^="progress-bar-"]');
      
      allProgressBars.forEach((progressBar, index) => {
        const barId = progressBar.id;
        const barNumber = barId.replace('progress-bar-', '');
        /* A <progress> vem de DENTRO da própria barra, não de um `getElementById`.
           A partir de 16/08/2026 as barras existem em dois lugares na página /cart —
           no drawer e no rodapé da página —, e um id repetido faria o
           `getElementById` devolver sempre a primeira: a segunda barra escreveria na
           <progress> da primeira e a sua ficaria congelada. O fallback por id fica
           como rede para qualquer marcação antiga que não aninhe as duas. */
        const progressEl = progressBar.querySelector('progress')
          || document.getElementById(`shipping-progress-${barNumber}`);
        
      if (progressEl) {
        const max = parseInt(progressEl.getAttribute('max') || '0', 10) || 0;
          const threshold = parseInt(progressBar.getAttribute('data-threshold') || '0', 10) || 0;
          const name = progressBar.getAttribute('data-name') || '';
          
          const effectiveThreshold = threshold || max;
          
          progressEl.setAttribute('value', String(subtotal));
          progressEl.setAttribute('max', String(effectiveThreshold));
          
          const label = progressBar.querySelector('.shipping-message') || progressEl.closest('.progress-bar')?.querySelector('label');
        if (label) {
            if (subtotal >= effectiveThreshold && effectiveThreshold > 0) {
              label.textContent = `Você ganhou frete grátis para ${name}!`;
            } else if (effectiveThreshold > 0) {
              const restante = Math.max(0, effectiveThreshold - subtotal);
              label.textContent = `Faltam ${formatMoneyCentsBRL(restante)} para frete grátis ${name}`;
            }
          }
        }
      });

      const productIdNum = parseInt((productId || '0').toString().replace(/[^0-9]/g, ''), 10) || 0;
      const desiredQtyStr = `${decimalQuantity.toFixed(1)} metros`;
      const newVariantNum = parseInt((newVariantId || '0').toString().replace(/[^0-9]/g, ''), 10) || 0;
      const matched = (cart.items || []).find((i) => {
        const sameProduct = parseInt(i.product_id, 10) === productIdNum;
        const samePropQty = i.properties && i.properties['_Quantidade'] === desiredQtyStr;
        const sameVariant = !newVariantNum || parseInt(i.variant_id, 10) === newVariantNum;
        return sameProduct && samePropQty && sameVariant;
      });
      
      if (matched && matched.key) {
        const oldKey = itemElement.dataset.key || '';
        const newKey = matched.key;
        
        itemElement.dataset.key = newKey;
        
        const removeButtons = itemElement.querySelectorAll('.remove-item');
        removeButtons.forEach(btn => {
          const oldBtnKey = btn.dataset.key;
          btn.dataset.key = newKey;
          
          btn.setAttribute('data-key', newKey);
        });
        
        const map = getCartKeyToProductMap();
        const cleanPid = String(productIdNum);
        if (oldKey && map[oldKey]) {
          delete map[oldKey];
        }
        map[newKey] = cleanPid;
        saveCartKeyToProductMap(map);
      }

      // Sempre usar updateSubtotalFromCart para manter consistência com descontos
      await updateSubtotalFromCart();
    } catch (error) {
    }
  }

  function validateStock(item, decimalQuantity, realQuantity) {
    let productId = item.dataset.productId || item.dataset.variantId;
    
      const cartKey = item.dataset.key;
      if (cartKey) {
      const mapped = extractProductIdFromKey(cartKey);
      if ((!productId || productId === 'null') && mapped) {
        productId = mapped;
      } else if (productId && productId !== 'null') {
        const hasStored = (getAvailableQuantityFromStorage(productId) !== null) || !!getProductDataFromStorage(productId);
        if (!hasStored && mapped) {
          productId = mapped;
        }
      }
    }
    
    /*
     * SEMPRE o valor que o Liquid calculou (data-available-quantity já é o disponível
     * DESTA linha, descontando o que outras linhas do mesmo produto ocupam).
     *
     * O `|| 999` que estava aqui tratava 0 como "sem limite", porque 0 é falsy em JS.
     * E 0 é um valor REAL e comum: tecido que esgotou enquanto o carrinho estava aberto
     * (a notificação de estoque do Tiny atualiza sozinha). Resultado: produto esgotado
     * aceitava qualquer metragem e a validação abaixo nunca reprovava — venda que a loja
     * não entrega, que é a quebra que este projeto existe para evitar.
     * `Number.isFinite` é o guarda certo, e é o que este arquivo já usa em
     * corrigirEsgotadoFalso (linha ~315) e no pré-aquecimento (~1628).
     *
     * Atributo ausente/ilegível não vira estoque infinito: cai no que a linha JÁ tem
     * salva, então o cliente mantém ou reduz, mas não aumenta sem lastro. Mesmo critério
     * que o Liquid aplica quando a metragem é desconhecida.
     */
    const dispoBruto = parseFloat(item.dataset.availableQuantity);
    const salvoNaLinha = (parseFloat(item.dataset.decimalQuantity) || 0) * (parseFloat(item.dataset.realQuantity) || 1);
    const availableQuantity = Number.isFinite(dispoBruto) ? dispoBruto : salvoNaLinha;

    // NÃO sobrescrever com dados do localStorage - sempre usar o metafield
    // O template Liquid já calcula a disponibilidade considerando produtos duplicados
    
    const totalRequested = decimalQuantity * realQuantity;
    
    if (totalRequested > availableQuantity) {
      showStockTooltip(item, `Disponível: ${availableQuantity.toFixed(1).replace('.', ',')}m`, 'error');
      return false;
    }
    
    hideStockTooltip(item);
    return true;
  }

  function showStockTooltip(item, message, type = 'error') {
    const tooltip = item.querySelector('.stock-validation-tooltip');
    if (tooltip) {
      tooltip.textContent = message;
      tooltip.className = `stock-validation-tooltip ${type}`;
      tooltip.classList.remove('hidden');
      
      setTimeout(() => {
        hideStockTooltip(item);
      }, 3000);
    }
  }

  function hideStockTooltip(item) {
    const tooltip = item.querySelector('.stock-validation-tooltip');
    if (tooltip) {
      tooltip.classList.add('hidden');
    }
  }

  function setItemEditingState(item, isEditing) {
    if (!item) return;

    item.classList.toggle('editing', isEditing);
    item.querySelectorAll('.remove-item').forEach(button => {
      button.hidden = isEditing;
      button.setAttribute('aria-hidden', isEditing ? 'true' : 'false');
      button.tabIndex = isEditing ? -1 : 0;
      if (isEditing) {
        button.style.setProperty('display', 'none', 'important');
      } else {
        button.style.removeProperty('display');
      }
    });
  }

  function closeAllEditorsExcept(exceptItem = null) {
    document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal.editing').forEach(item => {
      if (item !== exceptItem) {
        const input = item.querySelector('.quantity-input');
        if (input && input.dataset.originalValue) {
          // originalValue é canônico (ponto); o campo mostra em pt-BR
          input.value = formatDecimalBR(input.dataset.originalValue);
        }
        
        setItemEditingState(item, false);
        
        hideStockTooltip(item);
      }
    });
  }

  // PRÉ-AQUECIMENTO da edição no carrinho: ao mudar a metragem (antes de Confirmar),
  // cria a variante em segundo plano via DecimalCut. Assim, quando o cliente clica
  // Confirmar logo em seguida, a variante já propagou → sem 422/espera. Debounce+dedup.
  let preAquecerCartTimer = null;
  function preAquecerCorteCarrinho(cartItem) {
    if (!cartItem || !window.DecimalCut || typeof window.DecimalCut.preAquecerCorte !== 'function') return;
    clearTimeout(preAquecerCartTimer);
    preAquecerCartTimer = setTimeout(() => {
      const input = cartItem.querySelector('.quantity-input');
      if (!input) return;
      const metros = parseDecimalBR(input.value);
      if (!(metros >= 0.5)) return;
      /* NÃO aquecer acima do estoque. Pré-aquecer CRIA variante de verdade no catálogo —
         não é só cache. Sem este teto apareciam "60.0 metros" e "80.0 metros" em produtos
         que nunca tiveram esse corte: são valores de PASSAGEM de quem digita "60"/"80".
         Além de poluir, cada uma queima uma vaga do limite de 100 variantes por produto.
         Rastreia: variantes fantasma. */
      const maxLinha = parseFloat(cartItem.dataset.availableQuantity);
      if (Number.isFinite(maxLinha) && metros > maxLinha + 0.001) return;
      const productId = (cartItem.dataset.productId || '').toString().replace(/[^0-9]/g, '');
      const ppm = parseFloat(cartItem.dataset.pricePerMeter || '0');
      if (!productId || !(ppm > 0)) return;
      const titulo = cartItem.querySelector('.cart-item-title')?.textContent?.trim() || '';
      // aquece em background COM sondagem+cache — o Confirmar depois pega do cache.
      window.DecimalCut.preAquecerCorte(productId, metros, titulo, ppm, cartItem.dataset.productHandle || '');
      // 1200ms (era 250ms, curto demais: uma pausa normal entre teclas já disparava e
      // criava variante para cada passo). Fica ACIMA do ajuste automático de 1s, então
      // aquece o valor já corrigido para o máximo, não o que o cliente digitou a mais.
    }, 1200);
  }

  function initializeQuantityControls() {
    document.querySelectorAll('#cart-drawer-decimal .quantity-input').forEach(input => {
      if (input.value && input.value.includes(',')) {
        // display em vírgula, dado interno em ponto (ver nota acima)
        const americanValue = input.value.replace(',', '.');
        if (!input.dataset.originalValue) {
          input.dataset.originalValue = americanValue;
        }
      }
    });
    
    document.querySelectorAll('#cart-drawer-decimal .quantity-edit-button').forEach(button => {
      if (button.hasEditListener) return;
      button.hasEditListener = true;
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const cartItem = this.closest('.cart-item-decimal');
        const quantityEditControls = cartItem.querySelector('.quantity-edit-controls');
        
        if (!cartItem || !quantityEditControls) {
          return;
        }
        
        closeAllEditorsExcept(cartItem);
        cartItem.__excedeuEstoque = false; // começa a edição sem flag pendente

        setItemEditingState(cartItem, true);
        
        const input = cartItem.querySelector('.quantity-input');
        if (input) {
          const currentValue = parseFloat(input.value.replace(',', '.')) || 0.5;
          input.value = currentValue.toFixed(1).replace('.', ',');
          input.focus();
          input.select();
          
          // Add visual feedback when input value changes
          function addVisualFeedback() {
            input.classList.add('quantity-changed');

            // Escurecer o botão de confirmar quando o input muda
            const confirmBtn = cartItem.querySelector('.quantity-confirm');
            if (confirmBtn) {
              confirmBtn.classList.add('value-changed');
            }
            preAquecerCorteCarrinho(cartItem); // cria a variante já, antes do Confirmar

            setTimeout(() => {
              input.classList.remove('quantity-changed');
            }, 300);
          }
          
          /* Ajuste ATRASADO ao máximo enquanto o cliente digita. Travar a cada tecla
             brigaria com quem digita "45": ao teclar "4" o campo já se corrigiria. Espera
             a digitação PARAR (1s) e então baixa para o disponível, explicando o motivo.
             Só o MÁXIMO: corrigir o mínimo assim transformaria um "0" ainda incompleto em
             "0,5" no meio da digitação de "0,5". O mínimo segue avisando e sendo barrado
             no Confirmar. O timer fica no próprio campo — global, cancelaria o ajuste de
             outra linha em edição. */
          function ajustarAoMaximoComAtraso() {
            clearTimeout(input._timerMax);
            // Se o cliente digitou de volta um valor VÁLIDO (<= max), limpa a flag na
            // hora — assim, mesmo que antes tenha excedido, um clique-fora agora fecha
            // normal. Só a digitação genuína de valor válido limpa; o blur NÃO limpa
            // (senão desmarcaria a flag que o clamp atrasado acabou de pôr num valor já
            // corrigido, e o clique-fora fecharia). Rastreia: clicar fora fechava o seletor.
            const maxAgora = parseFloat(cartItem.dataset.availableQuantity);
            const vAgora = parseDecimalBR(input.value);
            if (Number.isFinite(maxAgora) && Number.isFinite(vAgora) && vAgora <= maxAgora) {
              cartItem.__excedeuEstoque = false;
            }
            input._timerMax = setTimeout(() => {
              const max = parseFloat(cartItem.dataset.availableQuantity);
              const v = parseDecimalBR(input.value);
              if (!Number.isFinite(max) || !Number.isFinite(v) || v <= max) return;
              input.value = formatDecimalBR(max);
              showStockTooltip(cartItem, `Disponível: ${formatDecimalBR(max)}m`, 'error');
              // o clamp atrasado também marca a flag (mantém o editor aberto no clique-fora)
              cartItem.__excedeuEstoque = true;
            }, 1000);
          }

          /* Ao SAIR do campo, normaliza o que foi digitado para pt-BR: "3.4" e "20.7"
             viram "3,4" e "20,7". parseDecimalBR já entende ponto como decimal; aqui só
             reescreve a exibição. Deixa vazio/inválido intacto (o Confirmar trata). */
          function normalizarExibicao() {
            clearTimeout(input._timerMax);
            const v = parseDecimalBR(input.value);
            if (!(v >= 0.5)) return;
            const max = parseFloat(cartItem.dataset.availableQuantity);
            // Se digitou acima do estoque, trava no máximo E AVISA quanto é — antes
            // travava calado (o cliente via o número mudar sozinho sem saber por quê).
            if (Number.isFinite(max) && v > max) {
              input.value = formatDecimalBR(max);
              showStockTooltip(cartItem, `Disponível: ${formatDecimalBR(max)}m`, 'error');
              // marca que houve correção: o handler de clicar-fora NÃO deve fechar o
              // editor calado nesse caso — mantém aberto com o aviso. Rastreia: clicar
              // fora fechava o seletor e engolia o aviso de estoque.
              cartItem.__excedeuEstoque = true;
            } else {
              input.value = formatDecimalBR(v);
              // NÃO limpa a flag aqui: no caso lento (clamp atrasado já deixou o valor
              // válido em 37 e marcou a flag), o blur veria "válido" e desmarcaria, e o
              // clique-fora fecharia. Quem limpa é a digitação de valor válido (acima).
            }
          }

          // Listen for manual input changes
          input.addEventListener('input', addVisualFeedback);
          input.addEventListener('input', ajustarAoMaximoComAtraso);
          input.addEventListener('blur', normalizarExibicao);

          // Listen for programmatic changes (from buttons)
          input.addEventListener('change', addVisualFeedback);
        }
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-button').forEach(button => {
      if (button.hasQuantityListener) return;
      button.hasQuantityListener = true;
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (this.classList.contains('plus') || this.classList.contains('minus')) {
          const input = this.parentNode.querySelector('.quantity-input');
          if (input) {
            let currentValue = parseDecimalBR(input.value);
            const step = this.classList.contains('plus') ? 0.1 : -0.1;
            const cartItem = input.closest('.cart-item-decimal');

            /* TRAVA nos limites em vez de só avisar. O seletor deixava passar qualquer
               valor (havia piso de 0,1 e NENHUM teto) e o erro só aparecia no Confirmar —
               o cliente montava 45 m de um tecido com 12 e só descobria depois. Agora o
               botão simplesmente para no limite, que é o comportamento esperado de um
               seletor. `data-available-quantity` aqui já é o disponível DESTA linha
               (o Liquid desconta as outras linhas do mesmo produto).
               O piso vira 0,5 (mínimo de venda) pelo mesmo motivo: descer até 0,1 só para
               o Confirmar recusar depois é a mesma falha ao contrário. */
            const maxLinha = parseFloat(cartItem && cartItem.dataset.availableQuantity);
            let newValue = Math.max(0.5, currentValue + step);
            let travou = '';
            if (Number.isFinite(maxLinha) && newValue > maxLinha) {
              newValue = Math.max(0.5, maxLinha);
              travou = `Disponível: ${newValue.toFixed(1).replace('.', ',')}m`;
            } else if (currentValue + step < 0.5) {
              travou = 'Quantidade mínima: 0,5m';
            }
            input.value = newValue.toFixed(1).replace('.', ',');
            if (travou && cartItem) showStockTooltip(cartItem, travou, 'error');

            // Add visual feedback directly
            input.classList.add('quantity-changed');

            // Escurecer o botão de confirmar quando o input muda
            const confirmBtn = cartItem?.querySelector('.quantity-confirm');
            if (confirmBtn) {
              confirmBtn.classList.add('value-changed');
            }
            if (cartItem) preAquecerCorteCarrinho(cartItem); // cria a variante já, antes do Confirmar

            setTimeout(() => {
              input.classList.remove('quantity-changed');
            }, 300);
          }
        }
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-confirm').forEach(button => {
      if (button.hasConfirmListener) return;
      button.hasConfirmListener = true;
      
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        if (isUpdating) {
          return;
        }

        const item = this.closest('.cart-item-decimal');
        const controls = item.querySelector('.quantity-controls[data-quantity-type="decimal"]');
        const input = controls.querySelector('.quantity-input');
        const newValue = parseDecimalBR(input.value);

        if (newValue < 0.5) {
          showStockTooltip(item, 'Quantidade mínima: 0,5m', 'error');
          return;
        }

        const currentDecimal = parseFloat(item.dataset.decimalQuantity);
        const currentReal = parseInt(item.dataset.realQuantity);
        let decimalQuantity = newValue;
        let realQuantity = currentReal;

        if (!validateStock(item, decimalQuantity, realQuantity)) {
          return;
        }

        setDrawerProcessing(true);
        
        // Add visual feedback to confirm button
        const confirmBtn = this;
        const originalBg = confirmBtn.style.backgroundColor;
        confirmBtn.style.backgroundColor = '#15803d';
        confirmBtn.style.transform = 'scale(0.95)';
        
        setTimeout(() => {
          confirmBtn.style.backgroundColor = originalBg;
          confirmBtn.style.transform = '';
        }, 150);

        try {
          // SEM UI otimista de preço/subtotal: reescrever a linha e ler o subtotal
          // ANTES da mutação (rede) mostrava linha nova vs subtotal velho (carrinho
          // pré-edição), ainda mais visível com o retry de propagação. Agora só o
          // input reflete o valor digitado + spinner; a fonte de verdade é o
          // refreshCartDataComplete DEPOIS da mutação. Rastreia: simplificação carrinho.
          input.value = formatDecimalBR(decimalQuantity);
          setItemEditingState(item, false);

          // Remover a classe value-changed do botão de confirmar
          const confirmBtn = item.querySelector('.quantity-confirm');
          if (confirmBtn) {
            confirmBtn.classList.remove('value-changed');
          }
        } catch (uiErr) {
        }

        const key = item.dataset.key;
        
        // Adicionar spinner no botão de confirmação
        const confirmBtnSpinner = item.querySelector('.quantity-confirm');
        if (confirmBtnSpinner) {
          // Adicionar spinner dentro do botão
          const spinner = document.createElement('div');
          spinner.className = 'quantity-loading-spinner';
          spinner.style.marginLeft = '8px';
          confirmBtnSpinner.appendChild(spinner);
          confirmBtnSpinner.disabled = true;
        }
        
        showLoading();
        const pararAvisos = avisosDeEspera(decimalQuantity.toFixed(1).replace('.', ','));

        const success = await updateCartQuantity(key, decimalQuantity, realQuantity);
        pararAvisos();

        // Restaurar botão de confirmação
        if (confirmBtnSpinner) {
          const spinner = confirmBtnSpinner.querySelector('.quantity-loading-spinner');
          if (spinner) {
            spinner.remove();
          }
          confirmBtnSpinner.disabled = false;
        }

        if (success) {
          // Atualizar valor mínimo e desconto após sucesso na atualização do carrinho
          setTimeout(async () => {
            try {
              const cartData = await getCartData();
              if (cartData) {
                updateMinimumOrderDisplay(cartData);
                updateDiscountDisplay(cartData);
              }
            } catch (e) {
              console.error('Erro ao atualizar valor mínimo:', e);
            }
          }, 100);
        } else {
          const err = window.cartDrawerDecimalLastError || {};
          try {
            const controls = item.querySelector('.quantity-controls[data-quantity-type="decimal"]');
            const inputRestore = controls?.querySelector('.quantity-input');
            if (inputRestore && inputRestore.dataset.originalValue) {
              inputRestore.value = formatDecimalBR(inputRestore.dataset.originalValue);
            }
            // Reverte o preço da linha otimista (68,77) para o valor real e
            // ressincroniza o subtotal a partir do carrinho REAL — senão a UI
            // fica mentindo (linha nova vs subtotal antigo) numa falha.
            try {
              const origDec = parseFloat((inputRestore?.dataset.originalValue || '0').toString().replace(',', '.')) || 0;
              const ppm = parseFloat(item.dataset.pricePerMeter || '0') || 0;
              const rq = parseInt(item.dataset.realQuantity || '1', 10) || 1;
              const priceEl = item.querySelector('.cart-item-price');
              if (priceEl && origDec > 0 && ppm > 0) {
                const lt = ppm * origDec * rq;
                priceEl.textContent = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
                  ? Shopify.formatMoney(Math.round(lt * 100))
                  : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(lt);
              }
            } catch (_p) {}
            try { await updateSubtotalFromCart(); } catch (_s) {}
            setItemEditingState(item, true);
            if (!shouldSuppressUpdateErrorMessage(err)) {
              err.body = getUserFacingErrorMessage(err);
              showStockTooltip(item, err?.body || 'Não foi possível atualizar. Tente novamente.', 'error');
            }
          } catch (_e) {
          }
        }

        setDrawerProcessing(false);
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-input').forEach((inputEl) => {
      if (inputEl.hasKeyboardListener) return;
      inputEl.hasKeyboardListener = true;

      inputEl.addEventListener('keydown', (event) => {
        const item = inputEl.closest('.cart-item-decimal');
        if (!item) return;
        if (event.key === 'Enter') {
          event.preventDefault();
          const confirmBtn = item.querySelector('.quantity-confirm');
          confirmBtn?.click();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          const cancelBtn = item.querySelector('.quantity-cancel');
          cancelBtn?.click();
        }
      });
    });

    document.querySelectorAll('#cart-drawer-decimal .quantity-cancel').forEach(button => {
      if (button.hasCancelListener) return;
      button.hasCancelListener = true;
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const item = this.closest('.cart-item-decimal');
        const controls = item.querySelector('.quantity-controls[data-quantity-type="decimal"]');
        const input = controls.querySelector('.quantity-input');
        
        if (input && input.dataset.originalValue) {
          // originalValue é canônico (ponto); o campo mostra em pt-BR
          input.value = formatDecimalBR(input.dataset.originalValue);
        }
        
        if (item) {
          setItemEditingState(item, false);
          
          // Remover a classe value-changed do botão de confirmar
          const confirmBtn = item.querySelector('.quantity-confirm');
          if (confirmBtn) {
            confirmBtn.classList.remove('value-changed');
          }
        }
        
        hideStockTooltip(item);
      });
    });
  }

  function initializeDrawerEvents() {
    const drawer = document.getElementById('cart-drawer-decimal');
    const drawerContentInit = drawer?.querySelector('.cart-drawer-content');
    
    if (drawer && drawerContentInit) {
      const cartItems = drawerContentInit.querySelectorAll('.cart-item-decimal');
      const cartEmptyDiv = drawerContentInit.querySelector('.cart-empty');
      const isEmpty = cartItems.length === 0 || !!cartEmptyDiv;
      
      if (isEmpty && !drawer.classList.contains('cart-empty')) {
        drawer.classList.add('cart-empty');
      } else if (!isEmpty && drawer.classList.contains('cart-empty')) {
        drawer.classList.remove('cart-empty');
      }
    }
    
    document.querySelectorAll('#cart-drawer-decimal [data-listener-initialized]').forEach(el => {
      el.removeAttribute('data-listener-initialized');
    });
    document.querySelectorAll('#cart-drawer-decimal [hasEditListener]').forEach(el => {
      el.hasEditListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasQuantityListener]').forEach(el => {
      el.hasQuantityListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasConfirmListener]').forEach(el => {
      el.hasConfirmListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasCancelListener]').forEach(el => {
      el.hasCancelListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasRemoveListener]').forEach(el => {
      el.hasRemoveListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasKeyboardListener]').forEach(el => {
      el.hasKeyboardListener = false;
    });
    document.querySelectorAll('#cart-drawer-decimal [hasCheckoutListener]').forEach(el => {
      el.hasCheckoutListener = false;
    });
    
    const closeButton = document.getElementById('close-cart-drawer-decimal');
    if (closeButton && !closeButton.dataset.listenerInitialized) {
      closeButton.dataset.listenerInitialized = 'true';
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeCartDrawer();
      });
    }

    const continueButtons = document.querySelectorAll('#cart-drawer-decimal .continue-shopping, #cart-drawer-decimal .btn-continue-shopping, #cart-drawer-decimal [href=""], #cart-drawer-decimal [href="#"]');
    continueButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        closeCartDrawer();
      });
    });

    const overlay = document.querySelector('#cart-drawer-decimal .drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          closeCartDrawer();
        }
      });
    }

    const drawerContentClick = document.querySelector('#cart-drawer-decimal .cart-drawer-content');
    // GUARDA de dedup: initializeDrawerEvents roda a cada abertura/render e o
    // .cart-drawer-content PERSISTE (só o innerHTML é trocado), então sem isto o listener
    // acumulava. Com N listeners e mutação de flag, o 1º consumia a flag e o 2º fechava —
    // o editor fechava mesmo com o aviso. Rastreia: clicar fora fechava o seletor.
    if (drawerContentClick && !drawerContentClick.__editorOutsideClickBound) {
      drawerContentClick.__editorOutsideClickBound = true;
      drawerContentClick.addEventListener('click', function(e) {
        const clickedInEditor = e.target.closest('.cart-item-decimal.editing .quantity-edit-controls');
        const clickedEditButton = e.target.closest('.quantity-edit-button');
        const clickedQuantityButton = e.target.closest('.quantity-button');
        const clickedQuantityInput = e.target.closest('.quantity-input');
        const clickedInEditingItem = e.target.closest('.cart-item-decimal.editing');

        if (!clickedInEditor && !clickedEditButton && !clickedQuantityButton && !clickedQuantityInput && !clickedInEditingItem) {
          const activeEditors = document.querySelectorAll('#cart-drawer-decimal .cart-item-decimal.editing');
          if (activeEditors.length > 0) {
            // Se o cliente digitou acima do estoque, mantém o editor aberto em vez de fechar
            // calado — ele decide (confirmar o máximo ou cancelar no ✗). NÃO muta a flag aqui
            // (só checa); quem a limpa é a digitação de valor válido.
            // se algum editor teve valor corrigido (digitou acima do estoque), NÃO fecha —
            // mantém aberto para o cliente decidir (confirmar o máximo ou cancelar no ✗).
            const temAviso = [...activeEditors].some((it) => it.__excedeuEstoque);
            if (!temAviso) closeAllEditorsExcept();
          }
        }
      });
    }

    const removeButtons = document.querySelectorAll('#cart-drawer-decimal .remove-item');
    removeButtons.forEach((button, index) => {
      if (!button.dataset.listenerInitialized) {
        button.dataset.listenerInitialized = 'true';
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          const key = this.dataset.key;
          
          if (key) {
            const success = await removeCartItem(key);
            if (success) {
              // Atualizar desconto após remover item
              setTimeout(async () => {
                try {
                  const cartData = await getCartData();
                  if (cartData) {
                    updateDiscountDisplay(cartData);
                  }
                } catch (e) {
                  console.error('Erro ao atualizar desconto após remoção:', e);
                }
              }, 100);
            }
          }
        });
      }
    });

    initializeQuantityControls();
    
    const checkoutButton = document.querySelector('#cart-drawer-decimal .checkout-button');
    if (checkoutButton && !checkoutButton.hasCheckoutListener) {
      checkoutButton.hasCheckoutListener = true;
      checkoutButton.addEventListener('click', function(e) {
        const spinner = this.querySelector('.spinner-container');
        if (spinner) {
          spinner.classList.add('show');
        }
        this.style.pointerEvents = 'none';
        this.disabled = true;
        
        // O spinner será removido quando a página redirecionar para o checkout
        // ou se houver erro, será removido pelo evento de erro
        window.addEventListener('beforeunload', function() {
          if (spinner) spinner.classList.remove('show');
        });
      });
    }

    document.querySelectorAll('#cart-drawer-decimal .js-close-drawer').forEach(btn => {
      if (btn._closeHandlerAttached) return;
      btn._closeHandlerAttached = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        closeCartDrawer();
      });
    });

    (async () => {
      try {
        const container = document.querySelector('#cart-drawer-decimal .product-recommendations-inline');
        if (!container) return;

        const productId = container.getAttribute('data-product-id');
        const limit = container.getAttribute('data-limit') || '10';
        const preferredIntent = container.getAttribute('data-intent') || 'complementary';
        const baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.product_recommendations_url) || '/recommendations/products';
        const wrapper = container.querySelector('.swiper-wrapper');
        if (!productId || !wrapper) return;

        async function fetchHtml(url) {
          const res = await fetch(url);
          if (!res.ok) return null;
          const html = await res.text();
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          return tmp;
        }

        async function tryHtmlVariants(intent) {
          let tmp = await fetchHtml(`${baseUrl}?product_id=${productId}&limit=${limit}&intent=${intent}`);
          if (tmp) {
            let slides = tmp.querySelectorAll('.product-recommendations .swiper-slide, [data-products-carousel] .swiper-slide');
            if (slides && slides.length) return Array.from(slides);
          }
          tmp = await fetchHtml(`${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${limit}&intent=${intent}`);
          if (tmp) {
            let slides = tmp.querySelectorAll('.product-recommendations .swiper-slide, [data-products-carousel] .swiper-slide');
            if (slides && slides.length) return Array.from(slides);
          }
          return null;
        }

        async function tryJson(intent) {
          try {
            const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`);
            if (!res.ok) return null;
            const data = await res.json();
            const products = data && (data.products || data);
            if (!products || !products.length) return null;
            return products.map(p => {
              const slide = document.createElement('div');
              slide.className = 'swiper-slide';
              const a = document.createElement('a');
              a.href = p.url || p.handle ? `/${p.handle}` : '#';
              a.className = 'card-product-cart';
              a.innerHTML = `
                <div class="card-product-cart-image">
                  <img src="${(p.featured_image && (p.featured_image.url || p.featured_image)) || ''}" alt="${(p.title || '').replace(/"/g,'&quot;')}">
                </div>
                <div class="card-product-cart-info">
                  <div class="card-product-cart-name"><h3>${p.title || ''}</h3></div>
                </div>`;
              slide.appendChild(a);
              return slide;
            });
          } catch (_e) { return null; }
        }

        let slides = await tryHtmlVariants(preferredIntent);
        if ((!slides || !slides.length) && preferredIntent !== 'related') {
          slides = await tryHtmlVariants('related');
        }
        if ((!slides || !slides.length)) {
          slides = await tryJson(preferredIntent) || await tryJson('related');
        }

        if (slides && slides.length) {
          wrapper.innerHTML = '';
          slides.forEach(slide => wrapper.appendChild(slide));
          setTimeout(() => initCartDrawerCarousel && initCartDrawerCarousel(), 0);
        } else {
          container.style.display = 'none';
        }
      } catch (e) {
      }
    })();
    
    setTimeout(() => {
      try {
        hasDrawerRecommendationsInitialized = false;
        populateDrawerRecommendations();
        initCartDrawerCarousel();
      } catch (e) {
      }
    }, 100);
  }

  document.addEventListener('cartItemAdded', function(e) {
    const productId = e.detail?.productId;
    if (productId) {
      const existingData = getProductDataFromStorage(productId);
      
      if (!existingData) {
        if (window.currentProductData) {
          saveProductData(window.currentProductData);
        }
        
        const genericData = localStorage.getItem('unidentified_product');
        if (genericData) {
          try {
            const parsedData = JSON.parse(genericData);
            
            const cleanProductId = productId.toString().replace(/[^0-9]/g, '');
            
            saveProductData({
              ...parsedData,
              productId: cleanProductId,
              id: cleanProductId
            });
          } catch (e) {
          }
        }
      }
    }
    
    // Não abrir o drawer se estivermos no template cart
    if (isCartTemplate()) {
      return;
    }

    // Abre SEM a carga inicial: o refreshCartDataComplete logo abaixo reconstrói tudo.
    // Deixar as duas rodarem produzia duas reconstruções em meio segundo — a piscada
    // dupla que aparecia no primeiro add da sessão.
    openCartDrawer({ pularCargaInicial: true });

    setTimeout(() => {
      try {
        // refreshCartDataComplete re-renderiza TODO o .cart-drawer-content (inclui o
        // footer com o subtotal do Liquid), mesmo caminho confiável da edição/remoção.
        // Antes usava refreshCartData (só o body) + updateSubtotalFromCart, e o
        // subtotal do footer ficava zerado no 1º add. Rastreia: simplificação carrinho.
        refreshCartDataComplete().then(async () => {
          setTimeout(() => {
            persistCartKeyProductMapFromDOM();
          }, 100);

          try { populateDrawerRecommendations && populateDrawerRecommendations(); } catch (_e) {}
          try { await updateHeaderCartCountFromCart(); } catch (_) {}
          agendarAutoHealEsgotado(); // some sozinho o "esgotou" transitório da propagação

          // Update discount display after adding products
          try {
            const cartResponse = await fetch('/cart.js');
            if (cartResponse.ok) {
              const cartData = await cartResponse.json();
              updateDiscountDisplay(cartData);
              /*
               * A BASE DO FRETE PRECISA SER INFORMADA AQUI. Rastreia: bug subtotal virou frete.
               *
               * Este caminho troca `refreshCartData + updateSubtotalFromCart` por
               * `refreshCartDataComplete`, que re-renderiza o footer pelo Liquid. O texto do
               * subtotal fica certo, mas `cbvFrete.definirBase` NUNCA e chamado — e ela e a
               * unica coisa que atualiza o `baseCents` do cart-frete.js. Medido em 31/08/2026:
               * com o carrinho vazio no load, baseCents fica 0; ao adicionar um item e escolher
               * a modalidade, `escreverSubtotal` faz 0 + frete e a linha vira o VALOR DO FRETE
               * (R$ 19,90 no carrinho, "Subtotal: R$ 16,68" na tela).
               *
               * `updateSubtotalFromCart` ja tem guard de sequencia e reaproveita este mesmo
               * carrinho, entao nao custa ida a rede. Roda DEPOIS do render da secao de
               * proposito: o HTML do Liquid sobrescreveria o valor corrigido.
               */
              try { await updateSubtotalFromCart(cartData); } catch (_) {}
            }
          } catch (_) {}
        }).catch(() => {
          try { populateDrawerRecommendations && populateDrawerRecommendations(); } catch (_e) {}
          try { updateSubtotalFromCart(); } catch (_) {}
          try { updateHeaderCartCountFromCart(); } catch (_) {}
        });
      } catch (_e) {
        try { populateDrawerRecommendations && populateDrawerRecommendations(); } catch (__e) {}
      }
    }, 50);
  });

  document.addEventListener('click', function(e) {
    if (e.target.matches('#open-cart-drawer-decimal') || e.target.closest('#open-cart-drawer-decimal')) {
      e.preventDefault();
      // Não abrir o drawer se estivermos no template cart
      if (isCartTemplate()) {
        return;
      }
      openCartDrawer();
      return;
    }
    
    if (e.target.matches('[data-toggle-cart]') || e.target.closest('[data-toggle-cart]')) {
      e.preventDefault();
      e.stopPropagation();
      
      // Não abrir o drawer se estivermos no template cart
      if (isCartTemplate()) {
        return;
      }
      
      setTimeout(() => {
        openCartDrawer();
      }, 10);
      return;
    }
    
    if (e.target.matches('#close-cart-drawer-decimal') || e.target.closest('#close-cart-drawer-decimal')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
    
    if (e.target.matches('.continue-shopping, .btn-continue-shopping, [href=""], [href="#"]') || e.target.closest('.continue-shopping, .btn-continue-shopping, [href=""], [href="#"]')) {
      if (e.target.closest('#cart-drawer-decimal')) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }
    }
    
    if (e.target.matches('#cart-drawer-decimal .remove-item') || e.target.closest('#cart-drawer-decimal .remove-item')) {
      e.preventDefault();
      e.stopPropagation();
      const button = e.target.matches('.remove-item') ? e.target : e.target.closest('.remove-item');
      const key = button?.dataset?.key;
      
      if (key) {
        setTimeout(async () => {
          const success = await removeCartItem(key);
          if (success) {
            // Atualizar desconto após remover item
            setTimeout(async () => {
              try {
                const cartData = await getCartData();
                if (cartData) {
                  updateDiscountDisplay(cartData);
                }
              } catch (e) {
                console.error('Erro ao atualizar desconto após remoção:', e);
              }
            }, 100);
          }
        }, 10);
      }
      return;
    }
    
    if (e.target.matches('#cart-drawer-decimal .drawer-overlay')) {
      closeCartDrawer();
      return;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      try {
        initializeDrawerEvents();
        corrigirEsgotadoFalso(); // o HTML servido pelo Liquid também pode trazer a tarja falsa
        updateSubtotalFromCart();
        updateHeaderCartCountFromCart();
      } catch (error) {
      }
    }, 100);
  });

  if (document.readyState === 'loading') {
  } else {
    setTimeout(() => {
      try {
        initializeDrawerEvents();
        corrigirEsgotadoFalso(); // o HTML servido pelo Liquid também pode trazer a tarja falsa
        updateSubtotalFromCart();
        updateHeaderCartCountFromCart();
      } catch (error) {
      }
    }, 50);
  }

  /*
   * VOLTAR DE PÁGINA — "excluo o item e ele volta" (3 clientes em out/2026, Safari).
   *
   * O navegador guarda a página inteira na memória (back-forward cache) e, no "voltar",
   * a devolve como estava: sem recarregar, sem DOMContentLoaded. O drawer, o subtotal e
   * o contador voltam com o carrinho de ANTES. Quem excluiu numa página e voltou para a
   * anterior vê os itens de novo, embora o carrinho na Shopify já esteja certo. O drawer
   * só lê o servidor na 1ª abertura (`hasDrawerContentInitialized`), então abrir de novo
   * não corrigia. Reproduzido em 14/10/2026: pageshow.persisted = true, drawer com 2
   * itens e o servidor com 1. O iPhone é o caso típico (gesto de deslizar para voltar).
   *
   * Só redesenha se a tela divergir do servidor, comparando as CHAVES das linhas (trocar
   * a metragem gera chave nova, então isso cobre exclusão, inclusão e edição).
   */
  async function sincronizarAposVoltar() {
    let cart;
    try {
      const res = await fetch(`/cart.js?ts=${Date.now()}`, { method: 'GET', headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!res.ok) return;
      cart = await res.json();
    } catch (_) { return; }

    try { await updateHeaderCartCountFromCart(cart); } catch (_) {}

    const drawer = document.getElementById('cart-drawer-decimal');
    if (!drawer) return;
    const naTela = [...drawer.querySelectorAll('.cart-item-decimal[data-key]')].map((el) => el.dataset.key).sort().join('|');
    const noServidor = (cart.items || []).map((i) => i.key).sort().join('|');
    if (naTela === noServidor) return;

    await refreshCartDataComplete();
    try { await updateSubtotalFromCart(cart); } catch (_) {}
    try { updateDiscountDisplay(cart); } catch (_) {}
    // a PDP recalcula a metragem disponível (ela desconta o que já está no carrinho).
    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (_) {}
  }

  window.addEventListener('pageshow', (ev) => {
    if (ev.persisted) sincronizarAposVoltar();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isDrawerOpen) {
      closeCartDrawer();
    }
  });

  // Coupon feedback functions
  function showCouponSuccess(message) {
    clearCouponMessages();
    
    const successElement = document.createElement('div');
    successElement.className = 'coupon-message coupon-success';
    successElement.textContent = message;
    
    /*
     * Vai LOGO ABAIXO DO CARTÃO de cupom. Antes ancorava no bloco de cupom aplicado,
     * que agora é uma etiqueta dentro do cabeçalho — a mensagem cairia lá dentro,
     * espremida ao lado do "×". O cartão é âncora estável: existe sempre, esteja o
     * corpo aberto ou fechado, com ou sem cupom aplicado.
     */
    const cartaoCupom = document.getElementById('drawer-cupom');
    const couponWrapper = document.querySelector('.cart-drawer-footer .cart-decimal-coupon');

    if (cartaoCupom) {
      cartaoCupom.insertAdjacentElement('afterend', successElement);
    } else if (couponWrapper) {
      couponWrapper.insertAdjacentElement('beforebegin', successElement);
    }
    
    setTimeout(() => {
      if (successElement) {
        successElement.remove();
      }
    }, 3000);
  }

  function showCouponError(message) {
    clearCouponMessages();
    
    const errorElement = document.createElement('div');
    errorElement.className = 'coupon-message coupon-error';
    errorElement.textContent = message;
    
    /*
     * Vai LOGO ABAIXO DO CARTÃO de cupom. Antes ancorava no bloco de cupom aplicado,
     * que agora é uma etiqueta dentro do cabeçalho — a mensagem cairia lá dentro,
     * espremida ao lado do "×". O cartão é âncora estável: existe sempre, esteja o
     * corpo aberto ou fechado, com ou sem cupom aplicado.
     */
    const cartaoCupom = document.getElementById('drawer-cupom');
    const couponWrapper = document.querySelector('.cart-drawer-footer .cart-decimal-coupon');

    if (cartaoCupom) {
      cartaoCupom.insertAdjacentElement('afterend', errorElement);
    } else if (couponWrapper) {
      couponWrapper.insertAdjacentElement('beforebegin', errorElement);
    }
    
    // Remove error message after 5 seconds
    setTimeout(() => {
      if (errorElement && errorElement.parentNode) {
        errorElement.remove();
      }
    }, 5000);
  }

  function clearCouponMessages() {
    const errorElement = document.querySelector('.coupon-error');
    if (errorElement) {
      errorElement.remove();
    }
    
    const successElement = document.querySelector('.coupon-success');
    if (successElement) {
      successElement.remove();
    }
    
    const messageElements = document.querySelectorAll('.coupon-message');
    messageElements.forEach(element => element.remove());
  }

  // Coupon functionality for cart drawer
  function initializeCouponFunctionality() {
    const couponInput = document.getElementById('cart-drawer-coupon-input');
    const couponButton = document.getElementById('cart-drawer-coupon-button');
    const appliedCouponCode = document.getElementById('cart-drawer-applied-coupon-code');
    const removeCouponBtn = document.getElementById('cart-drawer-remove-coupon-btn');
    const discountDiv = document.getElementById('cart-drawer-discount');
    const discountValue = document.getElementById('cart-drawer-discount-value');

    if (!couponInput || !couponButton) return;

          // Check for existing coupon on page load
          function checkExistingCoupon() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Check if there's a price change (indicating existing discount)
                const hasPriceChange = cart.original_total_price && cart.total_price && 
                                     cart.total_price < cart.original_total_price;
                
                if (hasPriceChange) {
                  // Try to get coupon code from localStorage first
                  const storedCoupon = localStorage.getItem('lastAppliedCoupon');
                  if (storedCoupon) {
                    const couponInput = document.getElementById('cart-drawer-coupon-input');
                    if (couponInput) {
                      couponInput.dataset.lastAppliedCoupon = storedCoupon;
                    }
                  }
                }
                
                // Update discount display and subtotal
                updateDiscountDisplay(cart);
              })
              .catch(error => {
                console.error('Error checking existing coupon:', error);
              });
          }

    // Check for existing coupon when the function initializes
    checkExistingCoupon();

    /*
     * O cupom digitado REALMENTE entrou no carrinho?
     *
     * Não adianta perguntar isso à resposta do /cart/update.js: com um código
     * inexistente ela volta 200 SEM campo `errors` (medido na loja real) — a Shopify
     * simplesmente ignora o código. A única prova é procurar o código no carrinho
     * DEPOIS de mandar aplicar.
     *
     * Procura nos DOIS níveis. Os cupons da CBV são "desconto no valor do produto" e
     * caem em items[].line_level_discount_allocations; só desconto de PEDIDO cai em
     * cart_level_discount_applications. Olhar um nível só reprova cupom legítimo — é a
     * mesma armadilha que já tinha escondido o cupom na exibição da /cart.
     *
     * O código antigo não olhava nada disso: dava por aplicado se houvesse QUALQUER
     * desconto no carrinho. Como o desconto automático do PIX é cart_level e derruba o
     * total, as três condições eram verdadeiras SEMPRE, e qualquer código inventado
     * recebia "Cupom aplicado com sucesso!".
     */
    function cupomNoCarrinho(cart, code) {
      const alvo = String(code || '').trim().toLowerCase();
      if (!alvo || !cart) return false;
      const bate = (app) => !!app && String(app.title || app.code || '').trim().toLowerCase() === alvo;
      if ((cart.cart_level_discount_applications || []).some(bate)) return true;
      return (cart.items || []).some((it) =>
        (it.line_level_discount_allocations || []).some((a) => bate(a.discount_application)));
    }

    // Título do cupom que já estava valendo (null se não houver). Exige
    // type "discount_code": desconto automático vem com type "" — é o caso do PIX,
    // que não é cupom e não pode ser "restaurado".
    function cupomVigente(cart) {
      if (!cart) return null;
      const doCarrinho = (cart.cart_level_discount_applications || []).find((d) => d && d.type === 'discount_code');
      if (doCarrinho) return doCarrinho.title || null;
      for (const it of cart.items || []) {
        for (const a of it.line_level_discount_allocations || []) {
          const app = a.discount_application;
          if (app && app.type === 'discount_code') return app.title || null;
        }
      }
      return null;
    }

    // Apply coupon
    function applyCoupon() {
      const couponCode = couponInput.value.trim();
      if (!couponCode) return;

      // Show loading state
      couponButton.disabled = true;
      const couponText = document.getElementById('cart-drawer-coupon-text');
      const couponSpinner = document.getElementById('cart-drawer-coupon-spinner');

      if (couponText) couponText.style.display = 'none';
      if (couponSpinner) couponSpinner.style.display = 'flex';

      const mandarCupom = (discount) => fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discount })
      }).then((r) => {
        if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
        return r.json();
      });
      const lerCarrinho = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

      // A Shopify guarda UM código por carrinho: tentar um código novo derruba o que
      // estava valendo. Por isso o anterior é guardado antes — se o novo não colar,
      // devolvemos o antigo em vez de deixar o cliente sem o desconto que já tinha.
      let anterior = null;

      lerCarrinho()
        .then((antes) => { anterior = cupomVigente(antes); })
        // sem saber o cupom vigente, não arrisca: lê de novo e, se falhar outra vez, não
        // manda o código novo (que derrubaria o vigente sem como devolver)
        .catch(() => lerCarrinho().then((antes) => { anterior = cupomVigente(antes); }))
        .then(() => mandarCupom(couponCode))
        .then(lerCarrinho)
        .then((depois) => {
          if (cupomNoCarrinho(depois, couponCode)) {
            couponInput.dataset.lastAppliedCoupon = couponCode;
            localStorage.setItem('lastAppliedCoupon', couponCode);
            showCouponSuccess('Cupom aplicado com sucesso!');
            updateDiscountDisplay(depois);
            couponInput.value = '';
            return null;
          }
          // Não entrou. Desfaz, restaurando o cupom anterior (ou limpando, se não havia),
          // pra não deixar um código inválido preso na sessão.
          return mandarCupom(anterior || '')
            .then(lerCarrinho)
            .then((restaurado) => {
              showCouponError('Cupom inválido ou não aplicável.');
              updateDiscountDisplay(restaurado);
            });
        })
        .catch((error) => {
          console.error('Error applying coupon:', error);
          showCouponError('Erro ao aplicar cupom. Tente novamente.');
        })
        .finally(() => {
          // Reset button state
          couponButton.disabled = false;
          if (couponText) couponText.style.display = 'flex';
          if (couponSpinner) couponSpinner.style.display = 'none';

          // Update subtotal once at the end
          updateSubtotalFromCart();
        });
    }

    // Remove coupon
    function removeCoupon() {
      // Show loading state
      const removeIcon = document.getElementById('cart-drawer-remove-icon');
      const removeSpinner = document.getElementById('cart-drawer-remove-spinner');
      
      if (removeIcon) removeIcon.style.display = 'none';
      if (removeSpinner) removeSpinner.style.display = 'flex';

      // Remove coupon from cart
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discount: ''
        })
      })
      .then(response => response.json())
      .then(data => {
        // Check if coupon was successfully removed
        if (!data.cart_level_discount_applications || data.cart_level_discount_applications.length === 0) {
          showCouponSuccess('Cupom removido com sucesso!');
        }
        
        // Update discount display and subtotal
        updateDiscountDisplay(data);
        
        // Update subtotal after removing coupon
        updateSubtotalFromCart();
      })
      .catch(error => {
        console.error('Error removing coupon:', error);
      })
      .finally(() => {
        // Reset button state
        if (removeIcon) removeIcon.style.display = 'flex';
        if (removeSpinner) removeSpinner.style.display = 'none';
      });
    }

    // Event listeners
    couponButton.addEventListener('click', applyCoupon);
    
    if (removeCouponBtn) {
      removeCouponBtn.addEventListener('click', removeCoupon);
    }
    
    couponInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        applyCoupon();
      }
    });
  }

  // Initialize coupon functionality when drawer events are initialized
  const originalInitializeDrawerEvents = initializeDrawerEvents;
  initializeDrawerEvents = function() {
    originalInitializeDrawerEvents();
    initializeCouponFunctionality();
  };

  /*
   * O rótulo da ação conta O QUE O CLIQUE VAI FAZER, não o nome do cartão.
   * Fechado diz "Calcular" ou "Adicionar"; aberto diz "Cancelar", porque aberto é
   * isso que o clique faz. Sem isso o botão fica dizendo "Calcular" com o campo de
   * calcular já na tela, e ninguém descobre como fechar.
   *
   * O texto de fechado vem do `data-rotulo` do próprio botão. Guardar numa variável
   * aqui não sobreviveria: o drawer é redesenhado a cada mudança de carrinho e o
   * botão volta do servidor novo em folha.
   */
  function rotularAcao(botao, aberto) {
    if (!botao) return;
    var fechado = botao.getAttribute('data-rotulo');
    botao.textContent = aberto ? 'Cancelar' : (fechado || botao.textContent);
  }

  var CHAVE_EXTRAS = 'cbv:extras-fechado';

  function guardarEstadoExtras(fechado) {
    try {
      if (fechado) sessionStorage.setItem(CHAVE_EXTRAS, '1');
      else sessionStorage.removeItem(CHAVE_EXTRAS);
    } catch (e) { /* navegação privada: só não lembra */ }
  }

  function aplicarEstadoExtras() {
    var caixa = document.getElementById('drawer-extras');
    var gat = document.getElementById('drawer-extras-gatilho');
    if (!caixa || !gat) return;
    var fechado = false;
    try { fechado = sessionStorage.getItem(CHAVE_EXTRAS) === '1'; } catch (e) { return; }

    /* SEM ANIMAR. Isto roda logo depois de um redesenho: animar aqui faria o bloco
       "fechar sozinho" à vista do cliente toda vez que ele mudasse uma metragem. O
       estado tem de aparecer já aplicado, como se nunca tivesse saído. */
    caixa.classList.add('sem-transicao');
    gat.classList.add('sem-transicao');
    caixa.classList.toggle('esta-fechado', fechado);
    gat.setAttribute('aria-expanded', fechado ? 'false' : 'true');
    var rot = document.getElementById('drawer-extras-rotulo');
    if (rot) {
      rot.textContent = fechado
        ? (gat.getAttribute('data-rotulo-fechado') || 'Calcular frete ou usar cupom')
        : (gat.getAttribute('data-rotulo-aberto') || 'Frete e cupom');
    }
    /* Devolve a transição só depois de o navegador ter pintado o estado novo — dois
       quadros, porque um só ainda cai dentro do mesmo ciclo de estilo e o clique
       seguinte sairia seco. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        caixa.classList.remove('sem-transicao');
        gat.classList.remove('sem-transicao');
      });
    });
  }

  /*
   * ⚠️ DELEGAÇÃO NO DOCUMENTO, e não `botao.addEventListener`.
   *
   * O drawer é REDESENHADO a cada busca de carrinho: o botão que recebeu o ouvinte é
   * jogado fora e nasce outro no lugar, sem ouvinte nenhum. Ligar direto no elemento
   * dava um sintoma que enganava — o primeiro clique depois de abrir o carrinho não
   * fazia nada e o segundo funcionava, conforme o redesenho tivesse acontecido ou não
   * no meio. Pego no teste de 14/08/2026, antes de publicar.
   *
   * O documento não é redesenhado: um ouvinte só, e resolve para sempre.
   */
  if (!window.__cbvExtrasLigado) {
    window.__cbvExtrasLigado = true;

    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;

      /* O cartão de Entrega é do `cart-frete.js` — cálculo, etiqueta do CEP e o "×"
         moram lá porque a página /cart usa os mesmos. Aqui ficou só o que é do
         drawer: o cupom e o gatilho que recolhe os dois cartões. */

      /* "Adicionar" do cupom. */
      if (ev.target.closest('#drawer-cupom-abrir')) {
        var cc = document.getElementById('drawer-cupom-corpo');
        var ci = document.getElementById('cart-drawer-coupon-input');
        if (cc) cc.hidden = !cc.hidden;
        rotularAcao(ev.target.closest('#drawer-cupom-abrir'), cc && !cc.hidden);
        if (ci && cc && !cc.hidden) ci.focus();
        return;
      }

      /*
       * Gatilho que esconde e mostra os dois cartões. Nasce ABERTO — a barra de frete
       * grátis mora dentro do cartão de Entrega e precisa ser vista antes de tudo.
       *
       * O rótulo troca ao fechar: aberto basta "Frete e cupom", mas fechado essa é a
       * única pista de que existe onde digitar cupom, e aí ele nomeia as duas ações.
       * `aria-expanded` é quem manda na seta (o CSS gira por ele), então não há um
       * segundo estado para desencontrar.
       */
      var gat = ev.target.closest('#drawer-extras-gatilho');
      if (gat) {
        var caixa = document.getElementById('drawer-extras');
        if (!caixa) return;
        // Classe, não `hidden`: `hidden` é display:none e mata a transição — o bloco
        // sumia de uma vez, que era a piscada. A classe deixa o CSS interpolar as
        // linhas do grid de 1fr a 0fr.
        var aberto = caixa.classList.toggle('esta-fechado') === false;
        gat.setAttribute('aria-expanded', aberto ? 'true' : 'false');
        // Guardado ANTES da animação: se a pessoa mexer no carrinho no meio dela, o
        // redesenho já encontra a escolha registrada.
        guardarEstadoExtras(!aberto);

        /*
         * O rótulo troca quando o movimento PARA, não no clique.
         *
         * Trocar no clique era o que fazia a animação parecer travada, e o culpado não
         * era o bloco: os dois textos têm larguras bem diferentes ("Frete e cupom" x
         * "Calcular frete ou usar cupom"), então o rótulo dava um salto de largura no
         * primeiro quadro, bem no canto do olho de quem acompanha o bloco descendo.
         * Esperar o `transitionend` deixa a troca acontecer com tudo parado.
         */
        var rot = document.getElementById('drawer-extras-rotulo');
        if (!rot) return;
        var novo = aberto
          ? (gat.getAttribute('data-rotulo-aberto') || 'Frete e cupom')
          : (gat.getAttribute('data-rotulo-fechado') || 'Calcular frete ou usar cupom');
        if (rot.textContent === novo) return;

        // Cliques rápidos não podem empilhar ouvinte nem deixar um timer velho
        // escrevendo o rótulo errado depois.
        if (caixa.__trocaRotulo) {
          caixa.removeEventListener('transitionend', caixa.__trocaRotulo);
          clearTimeout(caixa.__trocaTimer);
        }
        var trocar = function (e) {
          // O contêiner anima uma coisa só, mas um filho pode borbulhar a dele.
          if (e && e.target !== caixa) return;
          rot.textContent = novo;
          caixa.removeEventListener('transitionend', trocar);
          clearTimeout(caixa.__trocaTimer);
          caixa.__trocaRotulo = null;
        };
        caixa.__trocaRotulo = trocar;
        caixa.addEventListener('transitionend', trocar);
        /* Rede de segurança: com `prefers-reduced-motion`, ou com a aba em segundo
           plano, `transitionend` pode nunca disparar — e aí o rótulo ficaria mentindo
           para sempre. 400ms cobre os 260 da animação com folga. */
        caixa.__trocaTimer = setTimeout(trocar, 400);
        return;
      }
    });

    document.addEventListener('DOMContentLoaded', aplicarEstadoExtras);
    document.addEventListener('cart:updated', aplicarEstadoExtras);
    document.addEventListener('cart:refresh', aplicarEstadoExtras);
  }

  window.cartDrawerDecimal = {
    open: openCartDrawer,
    close: closeCartDrawer,
    refresh: refreshCartData,
    // o carrinho mudou por fora (outra aba, item de cotação do frete tirado ao
    // carregar a página): contador + drawer só se a tela divergir do servidor
    sincronizar: sincronizarAposVoltar,
    updateDiscountDisplay: updateDiscountDisplay
  };
  
  window.cartDrawerDecimalInitialized = true;

} else {
}
